const selectedOptions = {};

// ===== Local Storage Helpers =====
function saveWizardData(stepKey, value) {
  const saved = JSON.parse(localStorage.getItem('chimneyWizardData') || '{}');
  saved[stepKey] = value;
  localStorage.setItem('chimneyWizardData', JSON.stringify(saved));
}

function loadWizardData() {
  if (localStorage.getItem("chimneyWizardComplete") === "1") {
    //window.addEventListener("load", showResultsFromLocalStorage);
    showResultsFromLocalStorage();
    return;
  }

  const saved = JSON.parse(localStorage.getItem('chimneyWizardData') || '{}');

  Object.keys(saved).forEach((key) => {
    const value = saved[key];

    // Restore input values
    const radio = document.querySelector(`input[type="radio"][name="${key}"][value="${value}"]`);
    if (radio) {
      radio.checked = true;
    } else {
      const field = document.querySelector(`[name="${key}"]`);
      if (field) {
        field.value = value;
      }
    }

    // ✅ Also populate selectedOptions
    selectedOptions[key] = value;
  });
}

function clearWizardData() {
  localStorage.removeItem('chimneyWizardData');
}
// ===== End Local Storage Helpers =====

const fieldPageFlows = {
  Cathedral: [
    "installation",
    "stove_opening_diameter",
    "chimney_height_to_roof_ft",
    "chimney_height_to_roof_in",
    "Ceiling_Pitch",
    "roof_material",
    "roof_pitch",
    "distance_from_peak_ft",
    "distance_from_peak_in",
    "extended_roof_bracket_opt_in",
    "include_spark_arrestor",
    "include_snow_splitter"
  ],

  "Through-Wall": [
    "installation",
    "stove_opening_diameter",
    "chimney_height_to_roof_ft",
    "chimney_height_to_roof_in",
    "wall_thickness",
    "wall_straps_step",
    "roof_material",
    "roof_pitch",
    "distance_from_peak_ft",
    "distance_from_peak_in",
    "roog_overhang_step",
    "extended_roof_bracket_opt_in",
    "include_spark_arrestor",
    "include_snow_splitter"
  ],

  "Multi-Floor / Through Attic": [
    "installation",
    "stove_opening_diameter",
    "chimney_height_to_roof_ft",
    "chimney_height_to_roof_in",
    "additional_floors",
    "require_horizontal_offset",
    "obstruction_min_horizontal",
    "obstruction_max_vertical",
    "roof_material",
    "roof_pitch",
    "distance_from_peak_ft",
    "distance_from_peak_in",
    "extended_roof_bracket_opt_in",
    "include_spark_arrestor",
    "include_snow_splitter"
  ],

  default: []
};

const pageFlows = {
  Cathedral: [
    "installation-type",
    "stove-opening-diameter",
    "mf-chimney-height-to-roof",
    "mf-pitch-cathedral-ceiling",
    "roof-type",
    "roof-pitch",
    "extended-roof-bracket",
    "spark-arrestor",
    "snow-splitter",
  ],

  default: [
    "installation-type",
    "stove-opening-diameter",
    "mf-chimney-height-to-roof",
    "mf-additional-floors",
    "mf-horizontal-offset",
    "roof-type",
    "roof-pitch",
    "extended-roof-bracket",
    "spark-arrestor",
    "snow-splitter",
  ],
  "Through-Wall": [
    "installation-type",
    "stove-opening-diameter",
    "mf-chimney-height-to-roof",
    "mf-exit-wall-thickness",
    "wall-staps-step",
    "roof-type",
    "roof-pitch",
    "roog-overhang",
    "extended-roof-bracket",
    "spark-arrestor",
    "snow-splitter",
  ],
};

let pages = [...pageFlows.default];
let currentPageIndex = 0;
// Restore step if saved in localStorage
const savedPage = parseInt(localStorage.getItem("chimneyWizardCurrentPage"), 10);
// Decide which step to show
if (!isNaN(savedPage) && savedPage >= 0 && savedPage < pages.length) {
  const selectedValue = $('input[name="installation"]:checked').val();
  //alert(selectedValue)
  pages = pageFlows[selectedValue] || pageFlows.default;

  currentPageIndex = savedPage;

} else {
  currentPageIndex = 0;
}

// Only load data if we're starting from Step 0
if (currentPageIndex === 0) {
  loadWizardData();
} else {
  const saved = JSON.parse(localStorage.getItem('chimneyWizardData') || '{}');

  Object.keys(saved).forEach((key) => {
    const value = saved[key];

    // Restore input values
    const radio = document.querySelector(`input[type="radio"][name="${key}"][value="${value}"]`);
    if (radio) {
      radio.checked = true;
    } else {
      const field = document.querySelector(`[name="${key}"]`);
      if (field) {
        field.value = value;
      }
    }

    // ✅ Also populate selectedOptions
    selectedOptions[key] = value;
  });
}



//showPage(currentPageIndex); // ✅ Show only one step

// ✅ Force validation after load (in case fields are pre-filled)
let savedSurvey = localStorage.getItem("chimneyWizardComplete");
if (isNaN(savedSurvey)) {
  setTimeout(() => {
    validatePage();
  }, 500);
}

//const selectedOptions = {};

function updatePageFlowFromSelection() {
  const selectedValue = $('input[name="installation"]:checked').val();

  pages = pageFlows[selectedValue] || pageFlows.default;

  const currentPageId = document.querySelector('.page[style*="block"]')?.id;
  const newIndex = pages.indexOf(currentPageId);
  currentPageIndex = newIndex !== -1 ? newIndex : 0;

  showPage(currentPageIndex);
  validatePage();
}

function formatInches(decimalValue) {
  const whole = Math.floor(decimalValue);
  const decimal = decimalValue - whole;

  // If decimal is very small, just return whole number
  if (decimal < 0.0625) {
    return `${whole}`;
  }

  const fractions = [
    { value: 0.125, label: "1/8" },
    { value: 0.25, label: "1/4" },
    { value: 0.375, label: "3/8" },
    { value: 0.5, label: "1/2" },
    { value: 0.625, label: "5/8" },
    { value: 0.75, label: "3/4" },
    { value: 0.875, label: "7/8" }
  ];

  // Find closest fraction
  let closest = "";
  let minDiff = Infinity;

  for (const frac of fractions) {
    const diff = Math.abs(decimal - frac.value);
    if (diff < minDiff) {
      minDiff = diff;
      closest = frac.label;
    }
  }

  return closest ? `${whole} ${closest}` : `${whole}`;
}

function showPage(index) {
  pages.forEach((page, i) => {
    const el = $("#" + page);
    if (i === index) {
      if (page == 'extended-roof-bracket') {
        var calculated_sizes = caculateChimneySize(selectedOptions);
        $(".total_chimeny_height").text(formatInches(calculated_sizes.total_chimney_height))
        $(".chimney_height_above_roof").text(formatInches(calculated_sizes.chimney_height_above_roof_calculated))
      }
      el.fadeIn(300);
    } else {
      el.hide(); // or el.fadeOut(200); if you want smooth transition out too
    }
  });
  updateProgressBar();
}

function updateProgressBar() {
  const percentage = ((currentPageIndex + 1) / pages.length) * 100;
  document.querySelector(".chimney-progress-bar").style.width = percentage + "%";
  document
    .querySelector(".chimney-progress-bar")
    .setAttribute("aria-valuenow", percentage);
}

function validatePage() {
  const currentPage = document.getElementById(pages[currentPageIndex]);
  const inputs = currentPage.querySelectorAll(
    'input[type="radio"]:checked, select:not(:invalid)'
  );
  let isValid = true;

  const currentPageId = pages[currentPageIndex]; // ✅ Define this once for clarity

  if (currentPageId === "mf-chimney-height-to-roof") {
    const ft = currentPage.querySelector(
      'select[name="chimney_height_to_roof_ft"]'
    ).value;
    const inch = currentPage.querySelector(
      'select[name="chimney_height_to_roof_in"]'
    ).value;
    isValid = ft !== "" && inch !== "";
  } else if (currentPageId === "mf-horizontal-offset") {
    const requireOffset = currentPage.querySelector(
      'input[name="require_horizontal_offset"]:checked'
    );
    if (requireOffset && requireOffset.value === "1") {
      const horizontal = currentPage.querySelector(
        'input[name="obstruction_min_horizontal"]'
      ).value;
      const vertical = currentPage.querySelector(
        'input[name="obstruction_max_vertical"]'
      ).value;
      isValid = requireOffset && horizontal >= 1 && vertical >= 1;
    } else {
      isValid = !!requireOffset;
    }
  } else if (currentPageId === "mf-additional-floors") {
    const floors = currentPage.querySelector(
      'select[name="additional_floors"]'
    );
    isValid = floors && floors.value !== "";
  } else if (currentPageId === "mf-pitch-cathedral-ceiling") {
    const pitch = currentPage.querySelector('select[name="Ceiling_Pitch"]');
    isValid = pitch && pitch.value !== "";
  } else if (currentPageId === "mf-exit-wall-thickness") {
    const pitch = currentPage.querySelector('select[name="wall_thickness"]');
    isValid = pitch && pitch.value !== "";
  } else if (currentPageId === "roof-pitch") {
    const pitch = currentPage.querySelector('select[name="roof_pitch"]').value;
    const ft = currentPage.querySelector(
      'select[name="distance_from_peak_ft"]'
    ).value;
    const inch = currentPage.querySelector(
      'select[name="distance_from_peak_in"]'
    ).value;
    isValid = pitch !== "" && ft !== "" && inch !== "";
  } else {
    isValid = inputs.length > 0;
  }

  // Save all answered fields from current step
  const inputsToSave = currentPage.querySelectorAll('input[type="radio"]:checked, select, input[type=text], input[type=number]');
  inputsToSave.forEach((el) => {
    const name = el.name;
    const value = el.value;
    if (name && value) {
      saveWizardData(name, value);
    }
  });

  currentPage.querySelector(
    '.nav-button:not([onclick="previousPage()"])'
  ).disabled = !isValid;
}

function nextPage() {
  localStorage.removeItem("chimneyWizardComplete");
  if (currentPageIndex < pages.length - 1) {
    currentPageIndex++;
    localStorage.setItem("chimneyWizardCurrentPage", currentPageIndex);
    showPage(currentPageIndex);
    validatePage();

     // Scroll to the top of .app-container smoothly
    const appContainer = document.querySelector(".app-container");
    if (appContainer) {
      appContainer.scrollIntoView({ behavior: "smooth" });
    }
  }
}

function previousPage() {
  if (currentPageIndex > 0) {
    currentPageIndex--;
    //showPage(currentPageIndex);
    localStorage.setItem("chimneyWizardCurrentPage", currentPageIndex);
    showPage(currentPageIndex);
    validatePage();

     // Scroll to the top of .app-container smoothly
    const appContainer = document.querySelector(".app-container");
    if (appContainer) {
      appContainer.scrollIntoView({ behavior: "smooth" });
    }
  }
}

function parseBool(value) {
  return value === true || !!parseInt(value);
}

function openModal(modalId) {
  document.getElementById(modalId).style.display = "block";
}

function closeModal(modalId) {
  document.getElementById(modalId).style.display = "none";
}

// Initialization
showPage(currentPageIndex);

// Input listeners
document.querySelectorAll('input[type="radio"]').forEach((input) => {
  input.addEventListener("change", () => {
    selectedOptions[input.name] = input.value;
    validatePage();

    if (input.name === "installation") {
      updatePageFlowFromSelection();
    }

    if (input.name === "require_horizontal_offset") {
      document.getElementById("offset-details").style.display =
        input.value === "1" ? "block" : "none";
    }
  });
});

document.querySelectorAll("select").forEach((select) => {
  select.addEventListener("change", () => {
    selectedOptions[select.name] = select.value;
    validatePage();
  });
});

document.querySelectorAll('input[type="number"]').forEach((input) => {
  input.addEventListener("input", () => {
    selectedOptions[input.name] = input.value;
    validatePage();
  });
});

$(".show-more").click(function () {
  const textEl = $(this).parent().find(".text");
  $(this).text(
    textEl.hasClass("show-more-height") ? "Show Features ▴" : "Hide Features ▾"
  );
  textEl.toggleClass("show-more-height");
});

$(document).on("change", 'input[name="installation"]', function () {
  const installationValue = $('input[name="installation"]:checked').val();

  // Update the heading text and display it
  const installationHeading = $(".installation-type");
  installationHeading.text(installationValue);
  installationHeading.show();

  //alert('ccccc');

  // Show/hide images based on selection
  if (installationValue === "Cathedral") {
    $(".image-for-cathedral-other-option").show();
    $(".image-for-Through-Wall-other-option").hide();
    $(".image-for-all-other-option").hide();

    $(".roof-pitch-all").show();
    $(".roof-pitch-thorugh-wall").hide();
  } else if (installationValue === "Through-Wall") {
    $(".image-for-cathedral-other-option").hide();
    $(".image-for-Through-Wall-other-option").show();
    $(".image-for-all-other-option").hide();

    $(".roof-pitch-all").hide();
    $(".roof-pitch-thorugh-wall").show();
  } else {
    $(".image-for-cathedral-other-option").hide();
    $(".image-for-Through-Wall-other-option").hide();
    $(".image-for-all-other-option").show();

    $(".roof-pitch-all").show();
    $(".roof-pitch-thorugh-wall").hide();
  }
});

$(document).on("click", ".custom-resert-button-chimney-wizard", function () {
  localStorage.removeItem("chimneyWizardCurrentPage");
  localStorage.removeItem("chimneyWizardComplete");
  // Clear previous entries
  Object.keys(selectedOptions).forEach((key) => delete selectedOptions[key]);
  clearWizardData();
  const saved = JSON.parse(localStorage.getItem("chimneyWizardData") || "{}");
  
  // Refill with pruned data
  Object.keys(saved).forEach((key) => {
    selectedOptions[key] = pruned[key];
  });
  $(".cw-main-result").css('display', 'none');
  currentPageIndex = 0;
  showPage(currentPageIndex);
  validatePage();
});

let brandComponentMap = {};
let brandAdapterCache = {}; // Will store available adapters by brand

// Brand Adapter
const brandAdapters = {
  duraplus: [
    {
      label: 'Single Wall Black - Slip Connector',
      path: 'adapter.single_wall.slip_connector',
      installations: ['Multi-Floor / Through Attic', 'Cathedral', 'Through-Wall']
    },
    {
      label: 'Single Wall Black - Snap-Lock',
      path: 'adapter.single_wall.snap_lock',
      installations: ['Multi-Floor / Through Attic', 'Cathedral', 'Through-Wall']
    },
    {
      label: 'Single Wall Black - DuraBlack Chimney Adapter w/ Trim',
      path: 'adapter.single_wall.dvl',
      installations: ['Multi-Floor / Through Attic', 'Cathedral', 'Through-Wall']
    },
    {
      label: 'Double Wall Black - DVL',
      path: 'adapter.double_wall.adapter',
      installations: ['Multi-Floor / Through Attic', 'Cathedral', 'Through-Wall']
    }
  ],
  duratech: [
    {
      label: 'Single Wall Black - Slip Connector',
      path: 'adapter.single_wall.slip_connector',
      installations: ['Multi-Floor / Through Attic', 'Cathedral']
    },
    {
      label: 'Single Wall Black - Snap-Lock',
      path: 'adapter.single_wall.snap_lock',
      installations: ['Multi-Floor / Through Attic', 'Cathedral']
    },
    {
      label: 'Single Wall Black - DuraBlack Chimney Adapter w/ Trim',
      path: 'adapter.single_wall.dvl',
      installations: ['Multi-Floor / Through Attic', 'Cathedral']
    },
    {
      label: 'Double Wall Black - DVL',
      path: 'adapter.double_wall.adapter',
      installations: ['Multi-Floor / Through Attic', 'Cathedral']
    },
    {
      label: 'Finishing Collar with Adapter',
      path: 'adapter.any.finishing_collar',
      installations: ['Through-Wall']
    }
  ],
  selkirksuperpro: [
    {
      label: 'Single or Double Wall Adapter',
      path: 'adapter.any.adapter',
      installations: ['Multi-Floor / Through Attic', 'Cathedral', 'Through-Wall']
    }
  ],
  selkirkultratemp: [
    {
      label: 'Single Wall - Dripless Smoke Pipe Adapter',
      path: 'adapter.single_wall.dripless_adapter',
      installations: ['Multi-Floor / Through Attic', 'Cathedral']
    },
    {
      label: 'Single Wall or Double Wall - Chimney Adapter',
      path: 'adapter.single_wall.adapter',
      installations: ['Multi-Floor / Through Attic', 'Cathedral']
    },
    {
      label: 'Finishing Collar',
      path: 'adapter.any.finishing_collar',
      installations: ['Through-Wall']
    }
  ]
};

const duraPlusOffsetChart = [
  [6, 15, "", 1.5, 12],
  [6, 15, "6", 2.75, 18],
  [6, 15, "9", 3.5, 21],
  [6, 15, "12", 4.375, 24],
  [6, 15, "24", 7.5, 35.5],
  [6, 15, "36", 10.5, 47],
  [6, 15, "24+24", 13.25, 57.25],
  [6, 30, "", 3.75, 16],
  [6, 30, "6", 6, 20],
  [6, 30, "9", 7.5, 22.5],
  [6, 30, "12", 9, 25],
  [6, 30, "24", 15, 35.5],
  [6, 30, "36", 21, 45.75],
  [6, 30, "24+24", 26.375, 54.75],
  [7, 15, "", 1.75, 13.5],
  [7, 15, "6", 3, 19.375],
  [7, 15, "9", 3.75, 22.25],
  [7, 15, "12", 4.5, 25.125],
  [7, 15, "24", 7.75, 36.75],
  [7, 15, "36", 10.75, 48.5],
  [7, 15, "24+24", 13.5, 58.5],
  [7, 30, "", 3.75, 14.25],
  [7, 30, "6", 6, 20],
  [7, 30, "9", 7.5, 22.75],
  [7, 30, "12", 9, 24],
  [7, 30, "24", 15, 35.75],
  [7, 30, "36", 21, 46],
  [7, 30, "24+24", 26.5, 55],
  [8, 15, "", 1.75, 15.25],
  [8, 15, "6", 3, 19.5],
  [8, 15, "9", 3.75, 22.5],
  [8, 15, "12", 4.5, 25.5],
  [8, 15, "24", 7.5, 37],
  [8, 15, "36", 10.75, 48.5],
  [8, 15, "24+24", 13.5, 58.75],
  [8, 30, "", 3.75, 14.75],
  [8, 30, "6", 6.5, 20.75],
  [8, 30, "9", 8, 23.75],
  [8, 30, "12", 9, 24],
  [8, 30, "24", 15.25, 36.25],
  [8, 30, "36", 21.25, 46.75],
  [8, 30, "24+24", 26.75, 55.75],
];

const duraTechOffsetChart = [
  [6, 15, "0", 2, 16.5],
  [6, 15, "6", 3.25, 21.25],
  [6, 15, "9", 4, 24.125],
  [6, 15, "12", 4.75, 27],
  [6, 15, "18", 6.25, 32.75],
  [6, 15, "24", 8, 38.5],
  [6, 15, "36", 11, 50.25],
  [6, 15, "48", 14.25, 61.75],
  [6, 15, "48+6", 15.5, 66.5],
  [6, 15, "48+9", 16.25, 69.375],
  [6, 15, "48+12", 17, 72.25],
  [6, 15, "48+18", 18.5, 78],
  [6, 15, "48+24", 20, 83.375],
  [6, 30, "0", 4, 15.75],
  [6, 30, "6", 6.25, 20],
  [6, 30, "9", 7.75, 22.625],
  [6, 30, "12", 9.25, 25.25],
  [6, 30, "18", 12.25, 30.25],
  [6, 30, "24", 15.25, 35.5],
  [6, 30, "36", 21.25, 46],
  [6, 30, "48", 27.25, 56.25],
  [6, 30, "48+6", 29.75, 60.5],
  [6, 30, "48+9", 31.25, 63.125],
  [6, 30, "48+12", 32.75, 65.75],
  [6, 30, "48+18", 35.75, 54.75],
  [6, 30, "48+24", 38.75, 54.75],
  [7, 15, "0", 2, 16.5],
  [7, 15, "6", 3.25, 21.25],
  [7, 15, "9", 4, 24.125],
  [7, 15, "12", 4.75, 27],
  [7, 15, "18", 6.25, 32.75],
  [7, 15, "24", 8, 38.5],
  [7, 15, "36", 11, 50.25],
  [7, 15, "48", 14.25, 61.75],
  [7, 15, "48+6", 15.5, 66.5],
  [7, 15, "48+9", 16.25, 69.375],
  [7, 15, "48+12", 17, 72.25],
  [7, 15, "48+18", 18.5, 78],
  [7, 15, "48+24", 20, 83.375],
  [7, 30, "0", 4, 15.75],
  [7, 30, "6", 6.25, 20],
  [7, 30, "9", 7.75, 22.625],
  [7, 30, "12", 9.25, 25.25],
  [7, 30, "18", 12.25, 30.25],
  [7, 30, "24", 15.25, 35.5],
  [7, 30, "36", 21.25, 46],
  [7, 30, "48", 27.25, 56.25],
  [7, 30, "48+6", 29.75, 60.5],
  [7, 30, "48+9", 31.25, 63.125],
  [7, 30, "48+12", 32.75, 65.75],
  [7, 30, "48+18", 35.75, 54.75],
  [7, 30, "48+24", 38.75, 54.75],
  [8, 15, "0", 2, 16.5],
  [8, 15, "6", 3.25, 21.25],
  [8, 15, "9", 4, 24.125],
  [8, 15, "12", 4.75, 27],
  [8, 15, "18", 6.25, 32.75],
  [8, 15, "24", 8, 38.5],
  [8, 15, "36", 11, 50.25],
  [8, 15, "48", 14.25, 61.75],
  [8, 15, "48+6", 15.5, 66.5],
  [8, 15, "48+9", 16.25, 69.375],
  [8, 15, "48+12", 17, 72.25],
  [8, 15, "48+18", 18.5, 78],
  [8, 15, "48+24", 20, 83.375],
  [8, 30, "0", 4, 15.75],
  [8, 30, "6", 6.25, 20],
  [8, 30, "9", 7.75, 22.625],
  [8, 30, "12", 9.25, 25.25],
  [8, 30, "18", 12.25, 30.25],
  [8, 30, "24", 15.25, 35.5],
  [8, 30, "36", 21.25, 46],
  [8, 30, "48", 27.25, 56.25],
  [8, 30, "48+6", 29.75, 60.5],
  [8, 30, "48+9", 31.25, 63.125],
  [8, 30, "48+12", 32.75, 65.75],
  [8, 30, "48+18", 35.75, 54.75],
  [8, 30, "48+24", 38.75, 54.75],
];

const selkirkSuperProOffsetChart = [
  //size, degree, sect'n,     offset, rise
  [6, 15, "0", 1.125, 10],
  [6, 15, "6", 2.375, 14.25],
  [6, 15, "12", 4, 20.5],
  [6, 15, "18", 5.5, 26.25],
  [6, 15, "24", 7, 32],
  [6, 15, "6+24", 8.375, 36.75],
  [6, 15, "36", 10.125, 43.625],
  [6, 15, "6+36", 11.375, 48.375],
  [6, 15, "12+36", 13, 54.125],
  [6, 15, "18+36", 14.5, 60],
  [6, 15, "24+36", 16.125, 65.75],
  [6, 15, "6+24+36", 17.375, 70.5],
  [6, 15, "12+24+36", 19, 76.25],
  [6, 30, "0", 2.75, 11.625],
  [6, 30, "6", 5.25, 15.875],
  [6, 30, "12", 8.25, 21],
  [6, 30, "18", 11.25, 26.25],
  [6, 30, "24", 14.25, 31.375],
  [6, 30, "6+24", 16.625, 35.625],
  [6, 30, "36", 20.25, 41.875],
  [6, 30, "6+36", 22.625, 46],
  [6, 30, "12+36", 25.75, 51.25],
  [6, 30, "18+36", 28.625, 56.375],
  [6, 30, "24+36", 31.625, 61.625],
  [6, 30, "6+24+36", 34.125, 65.875],
  [6, 30, "12+24+36", 37.125, 71],
  [7, 15, "0", 1.125, 10.25],
  [7, 15, "6", 2.375, 15],
  [7, 15, "12", 4, 20.75],
  [7, 15, "18", 5.5, 26.5],
  [7, 15, "24", 7, 32.25],
  [7, 15, "6+24", 8.375, 37],
  [7, 15, "36", 10.25, 44],
  [7, 15, "6+36", 11.5, 48.625],
  [7, 15, "12+36", 13, 54.375],
  [7, 15, "18+36", 14.5, 60.125],
  [7, 15, "24+36", 16.125, 66],
  [7, 15, "6+24+36", 17.375, 70.75],
  [7, 15, "12+24+36", 19, 76.5],
  [7, 30, "0", 3.125, 13],
  [7, 30, "6", 5.625, 17.25],
  [7, 30, "12", 8.625, 22.375],
  [7, 30, "18", 11.625, 27.625],
  [7, 30, "24", 14.625, 32.875],
  [7, 30, "6+24", 17, 37],
  [7, 30, "36", 20.625, 43.25],
  [7, 30, "6+36", 23, 47.5],
  [7, 30, "12+36", 26, 52.625],
  [7, 30, "18+36", 29, 57.375],
  [7, 30, "24+36", 32, 63],
  [7, 30, "6+24+36", 34.5, 67.25],
  [7, 30, "12+24+36", 37.5, 72.5],
  [8, 15, "0", 1.25, 10.75],
  [8, 15, "6", 2.5, 15.625],
  [8, 15, "12", 4, 21],
  [8, 15, "18", 5.5, 26.75],
  [8, 15, "24", 7, 32.5],
  [8, 15, "6+24", 8.375, 37.25],
  [8, 15, "36", 10.25, 44.125],
  [8, 15, "6+36", 11.5, 48.875],
  [8, 15, "12+36", 13, 54.625],
  [8, 15, "18+36", 14.625, 60.375],
  [8, 15, "24+36", 16.125, 66.25],
  [8, 15, "6+24+36", 17.375, 71],
  [8, 15, "12+24+36", 19, 76.75],
  [8, 30, "0", 3.5, 14.5],
  [8, 30, "6", 6, 18.375],
  [8, 30, "12", 9, 24],
  [8, 30, "18", 12, 29.125],
  [8, 30, "24", 15, 32.375],
  [8, 30, "6+24", 17.125, 38.5],
  [8, 30, "36", 21, 44.75],
  [8, 30, "6+36", 23.5, 49],
  [8, 30, "12+36", 26.5, 54.125],
  [8, 30, "18+36", 29.5, 59.375],
  [8, 30, "24+36", 32, 64.5],
  [8, 30, "6+24+36", 35, 68.75],
  [8, 30, "12+24+36", 38, 74],
];

const selkirkUltraTempOffsetChart = [
  //size, degree, sect'n,offset, rise
  [6, 15, "0", 0.88, 7.63],
  [6, 15, "6", 2.1, 12.21],
  [6, 15, "9", 2.88, 15.11],
  [6, 15, "12", 3.66, 18.01],
  [6, 15, "18", 5.21, 23.8],
  [6, 15, "24", 6.76, 29.6],
  [6, 15, "36", 9.87, 41.19],
  [6, 15, "48", 12.97, 52.78],
  [6, 30, "0", 3.0, 12.5],
  [6, 30, "6", 5.38, 16.61],
  [6, 30, "9", 6.88, 19.21],
  [6, 30, "12", 8.38, 21.81],
  [6, 30, "18", 11.38, 27.01],
  [6, 30, "24", 14.38, 32.2],
  [6, 30, "36", 20.38, 42.59],
  [6, 30, "48", 26.38, 52.99],
  [7, 15, "0", 0.88, 8.75],
  [7, 15, "6", 2.1, 13.34],
  [7, 15, "9", 2.88, 16.24],
  [7, 15, "12", 3.66, 19.13],
  [7, 15, "18", 5.21, 24.93],
  [7, 15, "24", 6.76, 30.72],
  [7, 15, "36", 9.87, 42.32],
  [7, 15, "48", 12.97, 53.91],
  [7, 30, "0", 3.75, 14.5],
  [7, 30, "6", 6.13, 18.61],
  [7, 30, "9", 7.63, 21.21],
  [7, 30, "12", 9.13, 23.81],
  [7, 30, "18", 12.13, 29.01],
  [7, 30, "24", 15.13, 34.2],
  [7, 30, "36", 21.13, 44.59],
  [7, 30, "48", 27.13, 54.99],
  [8, 15, "0", 1.0, 8.25],
  [8, 15, "6", 2.23, 12.84],
  [8, 15, "9", 3.01, 15.74],
  [8, 15, "12", 3.78, 18.63],
  [8, 15, "18", 5.34, 24.43],
  [8, 15, "24", 6.89, 30.22],
  [8, 15, "36", 9.99, 41.82],
  [8, 15, "48", 13.1, 53.41],
  [8, 30, "0", 3.63, 14.5],
  [8, 30, "6", 6.0, 18.61],
  [8, 30, "9", 7.5, 21.21],
  [8, 30, "12", 9.0, 23.81],
  [8, 30, "18", 12.0, 29.01],
  [8, 30, "24", 15.0, 34.2],
  [8, 30, "36", 21.0, 44.59],
  [8, 30, "48", 27.0, 54.99],
];

const shastaVentOffsetChart = [
  //size, degree, sect'n, offset,     rise
  [6, 15, "0", 1, 7.625],
  [6, 15, "8", 2.75, 14.375],
  [6, 15, "19", 4.75, 25.625],
  [6, 15, "39", 11, 44.625],
  [6, 15, "39+8", 11 + 1.75, 44.625 + 6.75],
  [6, 15, "39+19", 11 + 4.75, 44.625 + 18],
  [6, 15, "39+39", 11 + 10, 44.625 + 37],
  [6, 30, "0", 3, 11],
  [6, 30, "8", 6.25, 17],
  [6, 30, "19", 12.25, 27.25],
  [6, 30, "39", 22, 44.25],
  [6, 30, "39+8", 22 + 3.5, 44.25 + 6],
  [6, 30, "39+19", 22 + 9.25, 44.25 + 16.25],
  [6, 30, "39+39", 22 + 19.25, 44.25 + 33.25],
  [8, 15, "0", 1, 7.625],
  [8, 15, "8", 2.75, 14.375],
  [8, 15, "19", 4.75, 25.625],
  [8, 15, "39", 11, 44.625],
  [8, 15, "39+8", 11 + 1.75, 44.625 + 6.75],
  [8, 15, "39+19", 11 + 4.75, 44.625 + 18],
  [8, 15, "39+39", 11 + 10, 44.625 + 37],
  [8, 30, "0", 3, 11],
  [8, 30, "8", 6.25, 17],
  [8, 30, "19", 12.25, 27.25],
  [8, 30, "39", 22, 44.25],
  [8, 30, "39+8", 22 + 3.5, 44.25 + 6],
  [8, 30, "39+19", 22 + 9.25, 44.25 + 16.25],
  [8, 30, "39+39", 22 + 19.25, 44.25 + 33.25],
];

let offsetCharts = {
  DuraPlus: duraPlusOffsetChart,
  DuraTech: duraTechOffsetChart,
  SelkirkSuperPro: selkirkSuperProOffsetChart,
  SelkirkUltraTemp: selkirkUltraTempOffsetChart,
  ShastaVent: shastaVentOffsetChart,
};

const lossOfConnectionMap = {
  DuraPlus: 1.5,
  DuraTech: 1.25,
  SelkirkSuperPro: 1.125,
  SelkirkUltraTemp: 1.25,
  ShastaVent: 1.0,
};

const adapterSkuMap = {
  DuraPlus: "duraPlus_adapter_sku",
  DuraTech: "duraTech_adapter_sku",
  SelkirkSuperPro: "selkirkSuperPro_adapter_sku",
  SelkirkUltraTemp: "selkirkUltraTemp_adapter_sku",
};

let total_chimney_height;
let chimney_height_above_roof;

let _MINIMUM_HEIGHT_ABOVE_ROOF = 36;
let _OBSTACLE_RADIUS = 120;
let _OBSTACLE_TERMINATION = 24;
let _EXTENDED_ROOF_BRACKET_HEIGHT = 48;

function caculateChimneySize(userMeasurements) {
  const chimney_height_to_roof =
    (parseInt(userMeasurements.chimney_height_to_roof_ft || 0) * 12) +
    (parseInt(userMeasurements.chimney_height_to_roof_in || 0));

  const total_distance_from_peak =
    (parseInt(userMeasurements.distance_from_peak_ft || 0) * 12) +
    (parseInt(userMeasurements.distance_from_peak_in || 0));

  const roof_pitch = parseFloat(userMeasurements.roof_pitch || 0);

  var chimney_height_above_roof_calculated = Math.max(
    36,
    Math.min(total_distance_from_peak, 120) * (roof_pitch / 12) +
    24
  );

  var total_chimney_height = chimney_height_to_roof + chimney_height_above_roof_calculated;

  // Optionally, store these back into the object:
  return {
    chimney_height_to_roof,
    total_distance_from_peak,
    chimney_height_above_roof_calculated,
    total_chimney_height
  };
}

function updateChimneyCalculations(userMeasurements) {
  const chimney_height_to_roof =
    (parseInt(userMeasurements.chimney_height_to_roof_ft || 0) * 12) +
    (parseInt(userMeasurements.chimney_height_to_roof_in || 0));

  const total_distance_from_peak =
    (parseInt(userMeasurements.distance_from_peak_ft || 0) * 12) +
    (parseInt(userMeasurements.distance_from_peak_in || 0));

  const roof_pitch = parseFloat(userMeasurements.roof_pitch || 0);

  chimney_height_above_roof = Math.max(
    36,
    Math.min(total_distance_from_peak, 120) * (roof_pitch / 12) +
    24
  );

  total_chimney_height = chimney_height_to_roof + chimney_height_above_roof;

  const include_extended_roof_bracket =
    chimney_height_above_roof >= 48 ||
    userMeasurements.extended_roof_bracket_opt_in === '1';

  const total_height = total_chimney_height;

  // Optionally, store these back into the object:
  return {
    chimney_height_to_roof,
    total_distance_from_peak,
    chimney_height_above_roof,
    total_chimney_height,
    include_extended_roof_bracket,
    total_height
  };
}

let calculated = {};

function submitSurvey(selectedAdapter = {}) {
  localStorage.removeItem("chimneyWizardCurrentPage");
  localStorage.setItem("chimneyWizardComplete", "1"); // ✅ Mark wizard as completed

  //document.body.style.overflow = "hidden";
  document.querySelector(".show_paritals_message").style.display = "none";
  document.querySelector(".show_notification").style.display = "none";
  document.querySelector(".result_previous_lage").style.display = "none";
  document.querySelector(".result_restart_button").style.display = "none";
  document.querySelectorAll(".cw-main-result .cpf-ctr").forEach(el => {
    el.style.display = "none";
  });

  document.querySelector(".show_loader_before_result").style.display = "grid";

  const saved = JSON.parse(localStorage.getItem("chimneyWizardData") || "{}");
  pruneFieldDataByInstallationType(saved.installation);

  const pruned = JSON.parse(localStorage.getItem("chimneyWizardData") || "{}");
  // Clear previous entries
  Object.keys(selectedOptions).forEach((key) => delete selectedOptions[key]);

  // Refill with pruned data
  Object.keys(pruned).forEach((key) => {
    selectedOptions[key] = pruned[key];
  });

  document.getElementById("snow-splitter").style.display = "none";
  document.querySelector(".svelte-g6m5ff").style.display = "flex";

  var userMeasurements = selectedOptions;

  //Display answer list

  // Get all survey answers
  const answers = getAllSurveyAnswers();

  // Create HTML for answers list
  let answersHTML = `
    <div class="survey-answers">
      <p class="copy_measurements">Copy</p>
      <h4>Your Measurements:</h4>
      <ul class="list-group list-group-flush mb-3">`;

  answers.forEach((item) => {
    answersHTML += `
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <div>
          <strong>${item.question}</strong><br>
          ${item.answer}
        </div>
        <button class="btn btn-sm btn-outline-primary edit-answer" data-page="${item.page}">Edit</button>
      </li>`;
  });

  answersHTML += `</ul></div>`;

  // Add the answers list to the results section
  const resultsContainer = document.querySelector(".svelte-g6m5ff");

  // Remove existing survey-answers if present
  const existingAnswers = resultsContainer.querySelector(".survey-answers");
  if (existingAnswers) {
    existingAnswers.remove();
  }

  resultsContainer.insertAdjacentHTML("afterbegin", answersHTML);
  // resultsContainer.innerHTML = answersHTML;


  // Add event listeners to edit buttons
  document.querySelectorAll(".edit-answer").forEach((button) => {
    button.addEventListener("click", function () {
      document.getElementById("snow-splitter").style.display = "grid";
      document.querySelector(".svelte-g6m5ff").style.display = "none";

      const pageToEdit = this.getAttribute("data-page");
      currentPageIndex = pages.indexOf(pageToEdit);
      showPage(currentPageIndex);
      validatePage();

      // Scroll to the wizard
      document.querySelector(".wizard-container").scrollIntoView({
        behavior: "smooth",
      });
    });
  });
  // display answer list

  // Validate for required options. Type-convert values. Calculate secondary measurements.
  if (!userMeasurements.installation) {
    console.log('CPF measurement "installation" missing. Abort.');
    return;
  }
  if (!userMeasurements.stove_opening_diameter) {
    console.log('CPF measurement "stove_opening_diameter" missing. Abort.');
    return;
  }

  //return false;

  let measurements = {
    // All measurements in inches unless otherwise specified.
    installation: userMeasurements.installation,
    chimney_height_to_roof_ft: parseInt(userMeasurements.chimney_height_to_roof_ft),
    chimney_height_to_roof_in: parseInt(userMeasurements.chimney_height_to_roof_in),
    distance_from_peak_ft: parseInt(userMeasurements.distance_from_peak_ft),
    distance_from_peak_in: parseInt(userMeasurements.distance_from_peak_in),
    Wall_strap: parseInt(userMeasurements.wall_straps_step),
    is_adjustable_wall_straps: parseInt(userMeasurements.wall_straps_step) == 1 ? true : false,
    Chimney_penetrate: 0, // Pending Need to find this

    stove_opening_diameter: parseInt(userMeasurements.stove_opening_diameter),
    stove_pipe_wall: userMeasurements.stove_pipe_wall || "single-wall",
    ceiling_pitch: parseInt(userMeasurements.ceiling_pitch) || 0,
    wall_thickness: parseInt(userMeasurements.wall_thickness) || 0,
    chimney_height_to_roof:
      parseInt(userMeasurements.chimney_height_to_roof) || 0,
    is_adjustable_wall_straps: parseBool(
      userMeasurements.is_adjustable_wall_straps
    ),
    additional_floors: parseInt(userMeasurements.additional_floors) || 0,
    require_horizontal_offset: parseInt(userMeasurements.require_horizontal_offset),
    obstruction_min_horizontal:
      parseInt(userMeasurements.obstruction_min_horizontal) || 0,
    obstruction_max_vertical:
      parseInt(userMeasurements.obstruction_max_vertical) || 0,
    penetrates_overhang: parseBool(userMeasurements.penetrates_overhang),
    roof_material: userMeasurements.roof_material || "Shingle",
    roof_pitch: parseInt(userMeasurements.roof_pitch) || 0,
    distance_from_peak: parseInt(userMeasurements.distance_from_peak) || 0,
    include_spark_arrestor: parseInt(userMeasurements.include_spark_arrestor),
    include_snow_splitter: parseInt(userMeasurements.include_snow_splitter),
    include_extended_roof_bracket: parseBool(
      userMeasurements.extended_roof_bracket_opt_in
    ),
    extended_roof_bracket_opt_in: parseInt(
      userMeasurements.extended_roof_bracket_opt_in
    ),
    duraPlus_adapter_sku: selectedAdapter["DuraPlus"],
    duraTech_adapter_sku: selectedAdapter["DuraTech"],
    selkirkSuperPro_adapter_sku: selectedAdapter["Selkirk SuperPro"],
    selkirkUltraTemp_adapter_sku: selectedAdapter["Selkirk Ultra Temp"],
  };

  calculated = updateChimneyCalculations(measurements);

  fetchData(measurements.stove_opening_diameter).then((data) => {
    const brandComponentMapUnClean = getAllBrandComponents(
      data,
      measurements
    );

    /*const availableBrands = Object.keys(brandComponentMapUnClean.brand_products);
    document.querySelectorAll('.cw-main-result .cpf-ctr').forEach((div) => {
      const brand = div.dataset.brandname;
      if (!availableBrands.includes(brand)) {
        div.style.display = 'none';
      } else {
        div.style.display = 'block';
      }
    });*/

    // brandComponentMap = deduplicateById(brandComponentMapUnClean);
    brandComponentMap = brandComponentMapUnClean;
    
    const handleMap = [];
    
    for (const brand in brandComponentMap.brand_products) {
      const products = brandComponentMap.brand_products[brand];
      products.forEach((product, index) => {
        const handle = product.url?.replace(/^\//, "").split("/").pop();
        if (handle) {
          handleMap.push({ brand, index, handle, originalSku: product.sku, category: product.category });
        }
      });
    }
    
    const fetchPromises = handleMap.map(({ handle }) =>
      fetch(`/products/${handle}.js`)
        .then((res) => res.ok ? res.json() : null)
        .catch(() => null)
    );

    var prices = '';
    
    Promise.all(fetchPromises).then((fetchedProducts) => {
      for (let i = handleMap.length - 1; i >= 0; i--) {
        const { brand, index, originalSku, category } = handleMap[i];
        const productInShopify = fetchedProducts[i];
    
        if (!productInShopify) {
          brandComponentMap.missing_products[brand].push(category); // <-- Add missing category
          // Product not found on Shopify
          brandComponentMap.brand_products[brand].splice(index, 1);
          continue;
        }
    
        // Find matching variant by SKU
        const matchingVariant = productInShopify.variants.find(
          (variant) => variant.sku === originalSku && variant.available
        );
    
        if (!matchingVariant) {
          brandComponentMap.missing_products[brand].push(category); // <-- Add missing category
          // No available matching variant found, remove the product
          brandComponentMap.brand_products[brand].splice(index, 1);
        } else {
          // Variant found, update the price from Shopify variant
          const shopifyPrice = matchingVariant.price / 100;
          brandComponentMap.brand_products[brand][index].price = shopifyPrice.toFixed(2);
          brandComponentMap.brand_products[brand][index].variant_id = matchingVariant.id;
        }
      }
    
      // ✅ Final clean brandComponentMap with only valid, available SKUs
      console.log("Cleaned + updated JSON:", brandComponentMap);


      document.querySelectorAll('.col.cpf-ctr').forEach(div => {
        const brand = div.dataset.brandname;
        const missing = brandComponentMap.missing_products[brand];

        // Hide by default
        const missingDiv = div.querySelector('div.brand_missing_products');
        if (missingDiv) {
          missingDiv.style.display = 'none';
        }

        if (missing && missing.length) {
          const ul = div.querySelector('ul.missing_products');

          if (ul) {
            // Clear existing list
            ul.innerHTML = '';

            // Use Set to ensure uniqueness
            const uniqueItems = [...new Set(missing)];

            uniqueItems.forEach(item => {
              const li = document.createElement('li');
              li.textContent = item;
              ul.appendChild(li);
            });

            // Show missing products container only if there are unique items
            if (missingDiv && uniqueItems.length > 0) {
              missingDiv.style.display = 'block';
            }
          }
        }
      });



      prices = calculatePrice(brandComponentMap);

      const priceElements = document.querySelectorAll(
        ".cpf-price#subtotal-price"
      );

      // Loop through each element and set the text content based on data-target
      priceElements.forEach((element) => {
        const target = element.getAttribute("data-target");
        if (target && prices[target]) {
          element.textContent = `$${prices[target]}`;
        }
      });

      const message = showBrandCompletionMessage(brandComponentMap.missing_products, Object.keys(brandComponentMap.brand_products).length);

      const adapterElements = document.querySelectorAll(".adaptor-list");

      adapterElements.forEach((element) => {
        const brand = element.getAttribute("data-target");
        const adapters = brandComponentMap['adapters'][brand] || [];
        const installationType = measurements.installation;

        // Filter adapters by installation type if provided
        const filteredAdapters = installationType
          ? adapters.filter(adapter => adapter.installations.includes(installationType))
          : adapters;

        // Set options
        element.innerHTML = setAdapters(filteredAdapters, selectedAdapter, brand);
      });

      document.querySelector(".show_paritals_message").style.display = "grid";

      document.querySelector(".show_notification").style.display = "block";
      document.querySelector(".result_previous_lage").style.display = "flex";
      document.querySelector(".result_restart_button").style.display = "block";

      const availableBrands = Object.keys(brandComponentMapUnClean.brand_products);
      document.querySelectorAll('.cw-main-result .cpf-ctr').forEach((div) => {
        const brand = div.dataset.brandname;
        if (!availableBrands.includes(brand)) {
          div.style.display = 'none';
        } else {
          div.style.display = 'block';
        }
      });

      //document.body.style.overflow = "";
      document.querySelector(".show_loader_before_result").style.display = "none";
    });



    
    /*document.querySelectorAll('.col.cpf-ctr').forEach(div => {
      const missingDiv = div.querySelector('div.brand_missing_products');
      if (missingDiv) {
        missingDiv.style.display = 'none';
      }
      const brand = div.dataset.brandname;
      const missing = brandComponentMap.missing_products[brand];

      if (missing && missing.length) {
        const ul = div.querySelector('ul.missing_products');
        if (ul) {
          ul.innerHTML = ''; // ✅ Clear existing data first
          missing.forEach(item => {
            const li = document.createElement('li');
            li.textContent = `${item}`;
            ul.appendChild(li);
          });
        }

        // Now show the missing products container
        if (missingDiv) {
          missingDiv.style.display = 'block';
        }
      }
    });*/
    // New Today Code End

    //var prices = calculatePrice(brandComponentMap);
    /*const priceElements = document.querySelectorAll(
      ".cpf-price#subtotal-price"
    );

    // Loop through each element and set the text content based on data-target
    priceElements.forEach((element) => {
      const target = element.getAttribute("data-target");
      if (target && prices[target]) {
        element.textContent = prices[target];
      }
    });*/

    /*const adapterElements = document.querySelectorAll(".adaptor-list");

    adapterElements.forEach((element) => {
      const brand = element.getAttribute("data-target");
      const adapters = brandComponentMap['adapters'][brand] || [];
      const installationType = measurements.installation;

      // Filter adapters by installation type if provided
      const filteredAdapters = installationType
        ? adapters.filter(adapter => adapter.installations.includes(installationType))
        : adapters;

      // Set options
      element.innerHTML = setAdapters(filteredAdapters, selectedAdapter, brand);
    });*/


  });
}

function showBrandCompletionMessage(missing_products, totalBrands) {
  let partialCount = 0;

  for (const brand in missing_products) {
    if (Array.isArray(missing_products[brand]) && missing_products[brand].length > 0) {
      partialCount++;
    }
  }

  const completedCount = totalBrands - partialCount;
  let message = "";

  if (completedCount === totalBrands) {
    message = `We've Found ${totalBrands} completed Options for You`;
    const showmsgContainer = document.querySelector('.show_only_partial_string');
    if (showmsgContainer) {
      showmsgContainer.style.display = 'none';
    }
  } else if (completedCount === 0) {
    message = `We've Found ${totalBrands} Partial Options for You`;
    const showmsgContainer = document.querySelector('.show_only_partial_string');
    if (showmsgContainer) {
      showmsgContainer.style.display = 'block';
    }
  } else {
    message = `We've Found ${completedCount} completed product${completedCount > 1 ? "s" : ""} and ${partialCount} Partial Option${partialCount > 1 ? "s" : ""} for You`;
    const showmsgContainer = document.querySelector('.show_only_partial_string');
    if (showmsgContainer) {
      showmsgContainer.style.display = 'none';
    }
  }

  // Example of where to display the message
  const msgContainer = document.querySelector('.show_paritals_message');
  if (msgContainer) {
    msgContainer.textContent = message;
  }

  return message;
}

async function fetchData(size) {
  // 1. requestOptions: used to configure the fetch request
  const requestOptions = {
    method: "GET",
    redirect: "follow",
  };

  try {
    // 3. response: holds the response object returned from fetch
    const response = await fetch(
      "https://leander-bc-php-apps.azurewebsites.net/apps/v1/nle/api/pf-c?size=" +
      size,
      requestOptions
    );

    // 4. result: stores the parsed JSON from the response
    const result = await response.json();

    console.log("Fetched inside fetchData:", result);

    // result is returned so it can be accessed from outside
    return result;
  } catch (error) {
    // 5. error: holds any error thrown during fetch or JSON parsing
    console.error("Fetch error:", error);
  }
}

// Chinney logic

function isInStock(sku, products) {
  return !!getProductBySKU(sku, products);
}

function getProductBySKU(sku, products) {
  return products.find((p) => p.sku === sku && p.inventory > 0) || null;
}

function getCatalogValue(catalog, path) {
  return path.split(".").reduce((obj, key) => obj?.[key], catalog);
}

function addElbowAndStrapsAndGetVerticalRise({
  offsetChart,
  userMeasurements,
  catalog,
  products,
  components,
  missingproducts
}) {
  let vertical_rise = 0;

  if (!Array.isArray(offsetChart)) {
    console.warn('❌ Missing offset chart');
    return vertical_rise;
  }

  const SIZE = 0;
  const DEGREES = 1;
  const SECTION = 2;
  const OFFSET = 3;
  const RISE = 4;

  const pipeDiameter = parseInt(userMeasurements.stove_opening_diameter);
  const minHorizontal = parseInt(userMeasurements.obstruction_min_horizontal);
  const maxVertical = parseInt(userMeasurements.obstruction_max_vertical);

  let bestPiece = null;

  for (const piece of offsetChart) {
    const sizeMatch = parseFloat(piece[SIZE]) === pipeDiameter;
    const offsetOK = parseFloat(piece[OFFSET]) >= minHorizontal;
    const riseOK = parseFloat(piece[RISE]) <= maxVertical;

    if (!(sizeMatch && offsetOK && riseOK)) continue;

    const elbowSKU =
      catalog?.elbow_kit?.stainless_steel?.[piece[DEGREES]] ||
      catalog?.elbow_kit?.[piece[DEGREES]] ||
      null;

    const elbowProduct = products.find(p => p.sku === elbowSKU && p.inventory > 0);
    if (!elbowProduct) continue;

    const sections = piece[SECTION] ? piece[SECTION].split('+') : [];

    let isMissingSection = false;

    for (const section of sections) {
      const sectionSKU =
        catalog?.chimney_pipe?.stainless_steel?.[section] ||
        catalog?.chimney_pipe?.[section] ||
        null;

      const sectionProduct = sectionSKU && products.find(p => p.sku === sectionSKU && p.inventory > 0);

      if (!sectionProduct) {
        isMissingSection = true;
        break;
      }
    }

    if (isMissingSection) {
      continue; // skip this piece
    }

    // Elbow strap check if multiple sections
    if (sections.length > 1) {
      const strapSKU = catalog?.elbow_strap;
      const strapProduct = strapSKU && products.find(p => p.sku === strapSKU && p.inventory > 0);
      if (!strapProduct) {
        continue; // skip if strap required and missing
      }
    }


    // Apply selection rules
    if (!bestPiece || piece[DEGREES] < bestPiece[DEGREES]) {
      bestPiece = piece;
    } else if (piece[DEGREES] === bestPiece[DEGREES] && piece[OFFSET] < bestPiece[OFFSET]) {
      bestPiece = piece;
    }
  }

  if (bestPiece) {
    const sections = bestPiece[SECTION] ? bestPiece[SECTION].split('+') : [];

    const elbowSKU =
      catalog?.elbow_kit?.stainless_steel?.[bestPiece[DEGREES]] ||
      catalog?.elbow_kit?.[bestPiece[DEGREES]] ||
      null;
    const elbowProduct = products.find(p => p.sku === elbowSKU && p.inventory > 0);
    //if (elbowProduct) components.push(elbowProduct);
    if (elbowProduct) {
      elbowProduct.category = 'Elbow';
      components.push(elbowProduct);
    } else {
      missingproducts.push("Elbow");
    }

    for (const section of sections) {
      const sectionSKU =
        catalog?.chimney_pipe?.stainless_steel?.[section] ||
        catalog?.chimney_pipe?.[section] ||
        null;
      const sectionProduct = products.find(p => p.sku === sectionSKU && p.inventory > 0);
      if (sectionProduct) components.push(sectionProduct);
    }

    if (sections.length > 1) {
      const strapSKU = catalog?.elbow_strap;
      const strapProduct = products.find(p => p.sku === strapSKU && p.inventory > 0);
      //if (strapProduct) components.push(strapProduct);
      if (strapProduct) {
        strapProduct.category = 'Strap';
        components.push(strapProduct);
      } else {
        missingproducts.push("Elbow & Strap");
      }
    }

    vertical_rise = parseFloat(bestPiece[RISE]);
  } else {
    console.warn('❌ No suitable elbow & straps found');
    missingproducts.push("Elbow & Strap");
  }

  return vertical_rise;
}


function getDeeplyNestedProperty(obj, path) {
  const keys = path.split('.');

  let current = obj;
  for (let key of keys) {
    if (current && typeof current === 'object') {
      current = current[key];
    } else {
      return undefined;
    }
  }

  return current;
}

function flattenAvailablePipe(pipe) {
  var flat = {};
  for (var material in pipe) {
    if (typeof pipe[material] === 'object') {
      for (var size in pipe[material]) {
        // Only set if size doesn't already exist (give priority to first found)
        if (!flat[size]) {
          flat[size] = pipe[material][size];
        }
      }
    } else {
      // Handle flat structure
      flat[material] = pipe[material];
    }
  }
  return flat;
}


function addChimneyPipe(totalHeightMinusOffset, catalog, products, components, missingproducts, loss_of_connection) {

  const chimneyPipeCatalog = catalog.chimney_pipe;
  if (!chimneyPipeCatalog || typeof chimneyPipeCatalog !== 'object') {
    console.warn('❌ Missing Chimney Pipe catalog');
    missingproducts.push("Chimney Pipe");
    return;
  }

  let availablePipe = getDeeplyNestedProperty(catalog, 'chimney_pipe');

  var sizeQtyPairs = [];
  var flatAvailablePipe = flattenAvailablePipe(availablePipe);
  var keys = Object.keys(flatAvailablePipe);

  for (var i = 0; i < keys.length; i++) {
    var size = keys[i];
    var sku = flatAvailablePipe[size];
    var product = sku ? products.find(p => p.sku === sku && p.inventory > 0) : null;

    var qty = 0;
    if (product && product.inventory) {
      qty = product.inventory;
    }

    sizeQtyPairs.push({
      size: size,
      qty: qty
    });
  }

  var optimalSizeQtyPairs = [];
  for (var j = 0; j < sizeQtyPairs.length; j++) {
    optimalSizeQtyPairs.push({
      size: sizeQtyPairs[j].size,
      qty: 9999
    });
  }

  // Calculate result using existing pipe fitting logic
  const result = getPipeWherePriorityFewestPiecesWithLimitedQuantityAndOverlap(
    totalHeightMinusOffset,
    sizeQtyPairs,
    loss_of_connection
  );

  const optimalResult = getPipeWherePriorityFewestPiecesWithLimitedQuantityAndOverlap(
    totalHeightMinusOffset,
    optimalSizeQtyPairs,
    loss_of_connection
  );

  //console.log(result);
  // Add valid SKUs to component list
  if (!result.missing_size && result.selectedPieces) {
    for (const size of result.selectedPieces) {
      const sku =
        catalog.chimney_pipe?.stainless_steel?.[size] ||
        catalog.chimney_pipe?.galvalume?.[size] ||
        catalog.chimney_pipe?.[size] ||
        null;

      const product = sku ? products.find(p => p.sku === sku && p.inventory > 0) : null;
      //if (product) components.push(product);
      if (product) {
        product.category = 'Chimney Pipe';
        components.push(product);
      } else {
        missingproducts.push("Chimney Pipe");
      }
    }

    if (result.selectedPieces.length > optimalResult.selectedPieces.length) {
      console.warn('⚠️ Chimney Pipe lengths selected are suboptimal');
      missingproducts.push("Chimney Pipe");
    }
  } else {
    console.warn(`❌ Missing Chimney Pipe lengths (short by ${result.missing_size} inches)`);
    missingproducts.push("Chimney Pipe");
  }
}

function getPipeWherePriorityFewestPiecesWithLimitedQuantityAndOverlap(goal_size, sizeQtyPairs, overlap) {

  goal_size = parseFloat(goal_size);
  if (goal_size < 0) console.warn('⚠️ goal_size must be a positive number.');
  overlap = parseFloat(overlap);

  if (!Array.isArray(sizeQtyPairs)) console.warn('⚠️ sizeQtyPairs must be an array.');

  const sizeQtyPairsSorted = sizeQtyPairs
    .map(pair => ({ size: parseFloat(pair.size), qty: parseInt(pair.qty, 10) }))
    .filter(pair => pair.size > overlap && pair.qty > 0)
    .sort((a, b) => b.size - a.size);

  if (!sizeQtyPairsSorted.length) console.warn('⚠️ sizeQtyPairs contains no valid pieces.');

  let actual_size = 0;
  const selectedPieces = [];

  for (let i = 0; i < 100 && sizeQtyPairsSorted.length && actual_size < goal_size; i++) {
    const selected_overlap = i ? overlap : 0;
    let selectedPiece = sizeQtyPairsSorted[0];

    for (let j = 1; j < sizeQtyPairsSorted.length; j++) {
      const candidate = sizeQtyPairsSorted[j];
      if (candidate.size - selected_overlap + actual_size < goal_size) break;
      selectedPiece = candidate;
    }

    selectedPieces.push(selectedPiece.size);
    actual_size += selectedPiece.size - selected_overlap;
    selectedPiece.qty--;

    if (selectedPiece.qty <= 0) {
      sizeQtyPairsSorted.splice(sizeQtyPairsSorted.indexOf(selectedPiece), 1);
    }
  }

  return {
    selectedPieces,
    actual_size,
    missing_size: Math.max(0, goal_size - actual_size)
  };
}

function addCeilingSupportBox(
  ceiling_pitch,
  brand,
  userMeasurements,
  catalog,
  products,
  components,
  missingproducts
) {
  // Brand-specific Ceiling Support charts
  const ceilingSupportCharts = {
    DuraPlus: [
      [4, 6, "11"],
      [9, 13, "24"],
      [14, 20, "36"],
    ],
    DuraTech: [
      [4, 6, "11"],
      [9, 13, "24"],
      [14, 20, "36"],
    ],
    SelkirkSuperPro: [[12, 12, "17"]],
    SelkirkUltraTemp: [[12, 12, "6"]],
    ShastaVent: [[16, 16, "24"]],
  };

  // Normalize brand key
  const normalizedBrand = brand.replace(/\s+/g, "");

  // Determine stove pipe wall type
  let stove_pipe_wall = userMeasurements.stove_pipe_wall; // fallback

  if (normalizedBrand === "DuraPlus") {
    stove_pipe_wall = [
      "NLE5SP_6DVL_ADT",
      "NLE5SP_7DVL_ADT",
      "NLE5SP_8DVL_ADT",
    ].includes(userMeasurements.duraPlus_adapter_sku)
      ? "double-wall"
      : "single-wall";
  }
  if (normalizedBrand === "DuraTech") {
    stove_pipe_wall = [
      "NLE5SP_6DVL_ADT",
      "NLE5SP_7DVL_ADT",
      "NLE5SP_8DVL_ADT",
    ].includes(userMeasurements.duraTech_adapter_sku)
      ? "double-wall"
      : "single-wall";
  }

  // Get brand's ceiling support chart
  const chart = ceilingSupportCharts[normalizedBrand];

  let box_row = null;

  if (stove_pipe_wall === "double-wall") {
    box_row = chart?.find((row) => ceiling_pitch <= row[1]);
  } else {
    box_row = chart?.find((row) => ceiling_pitch <= row[0]);
  }

  if (!box_row) {
    console.warn("❌ Missing: Ceiling Support Box");
    missingproducts.push("Ceiling Support Box");
  } else {
    const box_height = box_row[2];
    const sku = catalog.ceiling_support_box?.[box_height];
    const product = getProductBySKU(sku, products);
    if (product) {
      product.category = 'Ceiling Support Box';
      components.push(product); // optionally: { ...product, qty: 10 }
    } else {
      console.warn("❌ Ceiling Support Box not in stock:", box_height);
      missingproducts.push("Ceiling Support Box");
    }
  }
}

function deduplicateById(brandComponentMap) {
  const deduped = {};

  for (const brand in brandComponentMap) {
    const seen = new Set();
    deduped[brand] = [];

    for (const item of brandComponentMap[brand]) {
      if (!seen.has(item.id)) {
        deduped[brand].push(item);
        seen.add(item.id);
      }
    }
  }

  return deduped;
}

async function addUpsellProduct(components) {

  const SHOPIFY_DOMAIN = 'https://www.northlineexpress.com';
  const handles = [
    'asi-335-neutral-cure-clear-silicone-10-2-oz-cartridge-23618',
    'asi-600-high-performance-red-silicone-2-8-oz-tube-23624',
    'asi-502-high-performance-black-silicone-10-2-oz-cartridge-23619'
  ];
  for (const handle of handles) {
    try {
      const res = await fetch(`${SHOPIFY_DOMAIN}/products/${handle}.js`);
      if (res.ok) {
        const product = await res.json();
        //console.log('✅ Found product:', product);
        const variant = product.variants[0]; // use first variant

        const productObj = {
          id: `gid://shopify/Product/${product.id}`, // this is the Shopify GID
          name: `${product.title} - ${variant.title}`,
          sku: variant.sku,
          price: (parseFloat(variant.price) / 100).toFixed(2), // already string (like "386.99")
          url: product.handle,
          image: product.images?.[0] || '', // fallback to empty string if no image
          inventory: variant.inventory_quantity ?? 1, // fallback to 0 if null,
          variant_id: variant.id
        };

        components.push(productObj);
        break;
      } else {
        console.warn(`❌ Product not found: ${handle}`);
      }
    } catch (err) {
      console.error(`❌ Error fetching product for handle ${handle}:`, err);
    }
  }
}

function getValueFromCatalog(catalog, path) {
  return path.split('.').reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : null), catalog);
}

function getAllBrandComponents(data, userMeasurements) {
  const results = {
    adapters: {},
    brand_products: {},
    missing_products: {}
  };

  for (const brand in data) {
    const { config, products } = data[brand];
    const catalog = config.catalog;
    const normalizedBrand = brand.replace(/\s+/g, '');
    const components = [];
    const missingproducts = [];


    // --- Adapters List --- 
    const adapters = brandAdapters[normalizedBrand.toLowerCase()] || [];
    // Map adapter objects to include actual product SKUs from catalog
    /*const availableChimneyAdapters = adapters
      .map(adapter => {
        const sku = getValueFromCatalog(catalog, adapter.path);
        const product = products.find((p) => p.sku === sku && p.inventory > 0);
        if (product) {
          console.log(product.url+'>>>>>>>>>+++++++++ Adapter product')
        }
        return sku
          ? {
            ...adapter,
            sku // include resolved SKU for further processing
          }
          : null;
      })
      .filter(Boolean);

    results['adapters'][brand] = availableChimneyAdapters;*/


    /*const adapterValidationPromises = adapters.map((adapter) => {
      const sku = getValueFromCatalog(catalog, adapter.path);
      const product = products.find((p) => p.sku === sku && p.inventory > 0);

      if (!sku || !product || !product.url) {
        return Promise.resolve(null); // skip if any required info is missing
      }

      const handle = product.url.replace(/^\//, "").split("/").pop();

      return fetch(`/products/${handle}.js`)
        .then((res) => res.ok ? res.json() : null)
        .then((shopifyProduct) => {
          if (!shopifyProduct) return null;

          const matchingVariant = shopifyProduct.variants.find(
            (variant) => variant.sku === sku && variant.available
          );

          if (matchingVariant) {
            return {
              ...adapter,
              sku
            };
          }

          return null;
        })
        .catch(() => null);
    });

    Promise.all(adapterValidationPromises).then((validatedAdapters) => {
      const availableChimneyAdapters = validatedAdapters.filter(Boolean);

      results['adapters'][brand] = availableChimneyAdapters;

      console.log(`✅ Available Adapters for ${brand}:`, availableChimneyAdapters);
    });*/



    const adapterValidationPromises = adapters.map((adapter) => {
    const sku = getValueFromCatalog(catalog, adapter.path);
    const product = products.find((p) => p.sku === sku && p.inventory > 0);

    if (!sku || !product || !product.url) {
      return Promise.resolve(null);
    }

    const handle = product.url.replace(/^\//, "").split("/").pop();

    return fetch(`/products/${handle}.js`)
      .then((res) => res.ok ? res.json() : null)
      .then((shopifyProduct) => {
        if (!shopifyProduct) return null;

        const matchingVariant = shopifyProduct.variants.find(
          (variant) => variant.sku === sku && variant.available
        );

        if (matchingVariant) {
          return {
            ...adapter,
            sku,
            shopifyProduct,
            matchingVariant
          };
        }

        return null;
      })
      .catch(() => null);
  });

  Promise.all(adapterValidationPromises).then((validatedAdapters) => {
    const availableAdapters = validatedAdapters.filter(Boolean);

    // Store the available adapters in the brand-specific cache
    brandAdapterCache[brand] = availableAdapters;

    // Optionally assign to results object if you're using it
    results['adapters'][brand] = availableAdapters;

    console.log(`✅ Cached adapters for ${brand}`, brandAdapterCache[brand]);
  });


    // Now you can use availableChimneyAdapters in your UI or logic
    //console.log(`🔥 Adapters for ${brand}:`, availableChimneyAdapters);

    // --- Common helpers ---
    const getProductBySKU = (sku) => products.find((p) => p.sku === sku && p.inventory > 0) || null;

    const getPriorityProduct = (options) => {
      for (const sku of options) {
        const product = getProductBySKU(sku);
        if (product) return product;
      }
      return null;
    };

    const getProductInStockFromPath = (path) => {
      const parts = path.split('.');
      const sku = parts.reduce((obj, key) => obj?.[key], catalog);
      return getProductBySKU(sku);
    };

    // --- Upsell Product ---
    if (userMeasurements.Chimney_penetrate || (userMeasurements.installation === 'Multi-Floor / Through Attic' || userMeasurements.installation === 'Cathedral')) {
      addUpsellProduct(components);
    }

    // --- Chimney Pipe ---
    if (calculated.total_height) {
      let total_height_minus_offset = parseFloat(calculated.total_height);

      const isMultiFloor = userMeasurements.installation === 'Multi-Floor / Through Attic';
      const hasOffset = userMeasurements.require_horizontal_offset &&
        userMeasurements.obstruction_min_horizontal &&
        userMeasurements.obstruction_max_vertical;

      if (isMultiFloor && hasOffset) {
        // Since we have an offset, we can guarantee we need elbows
        // and guarantee a loss-of-connection. You can process elbow here if needed.
        const offsetChart = offsetCharts[normalizedBrand];
        const elbowRise = addElbowAndStrapsAndGetVerticalRise({
          offsetChart,
          userMeasurements,
          catalog,
          products,
          components,
          missingproducts
        });

        // Example usage (implement elbow/offset logic here if needed)
        total_height_minus_offset = total_height_minus_offset - elbowRise - lossOfConnectionMap[normalizedBrand];
      }

      // You can now use total_height_minus_offset for further processing
      //console.log("📏 Adjusted chimney height:", total_height_minus_offset);
      addChimneyPipe(total_height_minus_offset, catalog, products, components, missingproducts, lossOfConnectionMap[normalizedBrand]);
    }

    // Only Through Wall Components
    if (userMeasurements.installation === 'Through-Wall') {
      // --- Wall Thimble ---
      if (catalog.wall_thimble) {
        if (typeof catalog.wall_thimble === 'string') {
          // Direct SKU string
          const product = products.find((p) => p.sku === catalog.wall_thimble && p.inventory > 0);
          if (product) components.push(product);
        } else if (typeof catalog.wall_thimble === 'object') {
          // Structured object with material-specific SKUs
          const product = getPriorityProduct([catalog.wall_thimble.stainless_steel, catalog.wall_thimble.galvalume]);
          if (product) components.push(product);
        }
      }

      // --- Tee With Cap ---
      if (catalog.tee_with_cap) {
        if (typeof catalog.tee_with_cap === 'string') {
          // Case: direct SKU string
          const product = getProductBySKU(catalog.tee_with_cap);
          //if (product) components.push(product);
          if (product) {
            product.category = 'Tee Cap';
            components.push(product);
          } else {
            components.push(product);
            missingproducts.push("Tee Cap");
          }
        } else if (typeof catalog.tee_with_cap === 'object' && !Array.isArray(catalog.tee_with_cap)) {
          // Case: material-based object
          const product = getPriorityProduct([catalog.tee_with_cap.stainless_steel, catalog.tee_with_cap.galvalume]);
          //if (product) components.push(product);
          if (product) {
            product.category = 'Tee Cap';
            components.push(product);
          } else {
            components.push(product);
            missingproducts.push("Tee Cap");
          }
        } else {
          console.warn('Unsupported format for tee_with_cap');
          missingproducts.push("Tee Cap");
        }
      } else {
        missingproducts.push('Tee Cap');
      }

      // --- Tee Support Bracket ---
      if (catalog.tee_support_bracket) {
        if (typeof catalog.tee_support_bracket === 'string') {
          // Case: direct SKU string
          const product = getProductBySKU(catalog.tee_support_bracket);
          //if (product) components.push(product);
          if (product) {
            product.category = 'Support Bracket';
            components.push(product);
          } else {
            missingproducts.push('Support Bracket');
          }
        } else if (typeof catalog.tee_support_bracket === 'object' && !Array.isArray(catalog.tee_support_bracket)) {
          // Case: material-based object
          const product = getPriorityProduct([
            catalog.tee_support_bracket.stainless_steel,
            catalog.tee_support_bracket.galvalume,
          ]);
          //if (product) components.push(product);
          if (product) {
            product.category = 'Support Bracket';
            components.push(product);
          } else {
            missingproducts.push('Support Bracket');
          }
        } else {
          console.warn('Unsupported format for tee_support_bracket');
          missingproducts.push("Support Bracket");
        }
      } else {
        missingproducts.push('Support Bracket');
      }

      // --- Wall Branch ---
      if (userMeasurements.wall_thickness) {
        const thickness = parseFloat(userMeasurements.wall_thickness || 0);
        let product = null;

        // Helper to get product safely from either structure
        const getPipeSKU = (length, material) => {
          if (!catalog.chimney_pipe) return null;

          if (typeof catalog.chimney_pipe[material] === 'object') {
            // Nested by material (e.g., stainless_steel -> 12)
            return catalog.chimney_pipe[material]?.[length] || null;
          } else if (typeof catalog.chimney_pipe[length] === 'string') {
            // Flat structure (e.g., chimney_pipe["12"])
            return catalog.chimney_pipe[length] || null;
          }

          return null;
        };

        const tryProduct = (length, material) => {
          const sku = getPipeSKU(length, material);
          return sku ? products.find((p) => p.sku === sku && p.inventory > 0) : null;
        };

        if (thickness < 6) {
          product =
            tryProduct('12', 'stainless_steel') ||
            tryProduct('9', 'galvalume') ||
            tryProduct('12', 'galvalume') ||
            tryProduct('12'); // fallback for flat structure
        } else if (thickness >= 6 && thickness <= 8) {
          product = tryProduct('12', 'stainless_steel') || tryProduct('12', 'galvalume') || tryProduct('12'); // fallback for flat structure
        }

        if (product) {
          components.push(product);
        } else {
          console.warn('❌ Wall Branch Chimney Pipe Section not found for thickness:', thickness);
        }
      }

      // --- Wall Strap ---
      if (userMeasurements.Wall_strap) {
        const strapSpacingMap = {
          DuraPlus: 48,
          DuraTech: 96,
          SelkirkSuperPro: 96,
          SelkirkUltraTemp: 96,
          ShastaVent: 120
        };

        const heightToRoof = parseInt(userMeasurements.chimney_height_to_roof || 0);
        const strapSpacing = strapSpacingMap[normalizedBrand] || 48; // fallback to 48 if brand unknown
        const numStraps = Math.floor((heightToRoof * 12) / strapSpacing); // ft to in

        let product = null;

        if (userMeasurements.is_adjustable_wall_straps) {
          product =
            getProductInStockFromPath('wall_strap.adjustable.stainless_steel') ||
            getProductInStockFromPath('wall_strap.adjustable.galvalume') ||
            getProductInStockFromPath('wall_strap.adjustable');

          if (!product) {
            console.warn('❌ Missing: Adjustable Wall Straps');
            missingproducts.push("Wall Strap");
          }
        } else {
          product =
            getProductInStockFromPath('wall_strap.fixed.stainless_steel') ||
            getProductInStockFromPath('wall_strap.fixed.galvalume') ||
            getProductInStockFromPath('wall_strap.fixed');

          if (!product) {
            console.warn('❌ Missing: Fixed Wall Straps');
            missingproducts.push("Wall Strap");
          }
        }

        if (product) {
          for (let i = 0; i < numStraps; i++) {
            product.category = 'Wall Strap';
            components.push(product); // or { ...product, qty: 20 }
          }
        }
      }


    }


    // --- Roof Flashing ---
    if (userMeasurements.Chimney_penetrate || (userMeasurements.installation === 'Multi-Floor / Through Attic' || userMeasurements.installation === 'Cathedral')) {
      const roofMaterial = (userMeasurements.roof_material || 'shingle').toLowerCase().replace(/ /g, '_');
      const roofPitch = parseInt(userMeasurements.roof_pitch, 10);
      const flashing = catalog.roof_flashing?.[roofMaterial];

      if (flashing) {
        const range = Object.keys(flashing).find((r) => {
          const [min, max] = r.split('-').map(Number);
          return roofPitch >= min && roofPitch <= max;
        });
        if (range) {
          const product = getProductInStockFromPath(`roof_flashing.${roofMaterial}.${range}`);
          //if (product) components.push(product);
          if (product) {
            product.category = 'Roof Flashing';
            components.push(product);
          } else {
            missingproducts.push("Roof Flashing");
          }
        }
      } else {
        missingproducts.push("Roof Flashing");
      }

      // --- Storm Collar (only if chimney penetrates roof)
      if (catalog.storm_collar) {
        const stormCollar = getProductBySKU(catalog.storm_collar);
        if (stormCollar) {
          stormCollar.category = 'Storm Collar';
          components.push(stormCollar); // optionally: { ...stormCollar, qty: 45 }
        } else {
          console.warn('❌ Missing: Storm Collar');
          missingproducts.push("Storm Collar");
        }
      }
    }

    // --- Insulation Shield ---
    if (userMeasurements.installation === 'Multi-Floor / Through Attic') {
      const product = getProductBySKU(catalog.attic_insulation_shield);
      if (product) {
        product.category = 'Attic Insulation Shield';
        components.push(product); // optionally: { ...product, qty: 35 }
      } else {
        console.warn('❌ Missing: Attic Insulation Shield');
        missingproducts.push("Attic Insulation Shield");
      }
    }

    if (userMeasurements.installation !== 'Through-Wall') {
      // --- Ceiling Support Box
      const ceiling_pitch = userMeasurements.installation === 'Cathedral' ? parseFloat(userMeasurements.ceiling_pitch || 0) : 0;
      addCeilingSupportBox(ceiling_pitch, brand, userMeasurements, catalog, products, components, missingproducts);
    }


    // --- Stove Pipe Adapter ---
    const adapterKey = adapterSkuMap[normalizedBrand];
    if (adapterKey && userMeasurements[adapterKey]) {
      const adapterSKU = userMeasurements[adapterKey];
      const product = getProductBySKU(adapterSKU, products);

      if (product) {
        product.category = 'Stove Pipe Adapter';
        components.push(product); // optionally add qty: 1
      } else {
        console.warn('❌ Missing: Stove Pipe Adapter');
        missingproducts.push("Stove Pipe Adapter");
      }
    }

    // --- Extended Roof Brackets ---
    if (userMeasurements.extended_roof_bracket_opt_in == 1) {
      const product = getProductBySKU(catalog.extended_roof_bracket);
      if (product) {
        product.category = 'Extended Roof Bracket';
        components.push(product); // optionally: { ...product, qty: 55 }
      } else {
        console.warn('❌ Missing: Extended Roof Bracket');
        missingproducts.push("Extended Roof Bracket");
      }
    }

    // --- Additional Floors ---
    if (
      userMeasurements.installation === 'Multi-Floor / Through Attic' &&
      userMeasurements.additional_floors &&
      catalog.firestop_radiation_shield
    ) {
      const sku = catalog.firestop_radiation_shield;
      const product = products.find((p) => p.sku === sku);
      const floors = parseInt(userMeasurements.additional_floors, 10);

      if (product && product.inventory >= floors) {
        for (let i = 0; i < floors; i++) {
          components.push(product); // optionally: { ...product, qty: 30 }
        }
      } else {
        console.warn(`❌ Firestop Radiation Shield (${floors} required, ${product?.inventory ?? 0} available)`);
      }
    }

    // --- Storm Collar ---
    /*if (catalog.storm_collar) {
        const product = getProductBySKU(catalog.storm_collar);
        if (product) components.push(product);
    }*/

    // --- Snow Splitter ---
    if (userMeasurements.include_snow_splitter === '1' || userMeasurements.include_snow_splitter === 1) {
      const product = getProductBySKU(catalog.snow_splitter);
      //if (product) components.push(product);
      if (product) {
        product.category = 'Snow Splitter';
        components.push(product);
      } else {
        missingproducts.push('Snow Splitter');
      }
    }
    // --- Spark Arrestor + Chimney Cap ---
    if (userMeasurements.include_spark_arrestor === '1' || userMeasurements.include_spark_arrestor === 1) {
      if (['DuraTech', 'Selkirk SuperPro', 'Selkirk Ultra Temp'].includes(brand)) {
        if (catalog.spark_arrestor) {
          //alert(catalog.spark_arrestor)
          const sa = getProductBySKU(catalog.spark_arrestor);
          //if (sa) components.push(sa);
          if (sa) {
            sa.category = 'Spark Arrestor';
            components.push(sa);
          } else {
            missingproducts.push('Spark Arrestor');
          }
        } else {
          missingproducts.push('Spark Arrestor');
        }
      }
      const cap = getProductBySKU(catalog.chimney_cap);
      //if (cap) components.push(cap);
      if (cap) {
        cap.category = 'Chimney Cap';
        components.push(cap);
      } else {
        missingproducts.push('Chimney Cap');
      }
    } else {
      // Only add chimney cap if brand is DuraPlus, Selkirk SuperPro, or SelkirkUltraTemp
      if (['DuraPlus', 'Selkirk SuperPro', 'Selkirk Ultra Temp'].includes(brand)) {
        const cap = getProductBySKU(catalog.chimney_cap);
        //if (cap) components.push(cap);
        if (cap) {
          product.category = 'Chimney Cap';
          components.push(cap);
        } else {
          missingproducts.push('Chimney Cap');
        }
      }
    }

    // Store result per brand
    results['brand_products'][brand] = components;
    results['missing_products'][brand] = missingproducts;
  }

  return results;
}

// Chimney logic

const modal = document.getElementById("brandModal");
const modalTitle = document.getElementById("brandModalTitle");
const modalBody = document.getElementById("brandModalBody");

function openBrandModal(brand) {
  const products = brandComponentMap['brand_products'][brand];
  modalTitle.innerText = `${brand} Parts List`;

  if (!products || products.length === 0) {
    modalBody.innerHTML = "<p>No parts available for this brand.</p>";
  } else {
    // Deduplicate by SKU and count quantities
    const productMap = new Map();

    products.forEach((product) => {
      const sku = product.sku;
      if (productMap.has(sku)) {
        productMap.get(sku).quantity += 1;
      } else {
        productMap.set(sku, { ...product, quantity: 1 });
      }
    });

    // Generate HTML from the deduplicated and counted products
    modalBody.innerHTML = Array.from(productMap.values())
      .map(
        (product) => `
          <div class="wizard-description-main">
            <img src="${product.image}" alt="${product.name}">
            <div class="wizard-description">
              <span class="wizard-name">${product.name.replace(/ - Default Title$/, '')}</span>
              <span class="wizard-sku">SKU: ${product.sku}</span>
              <span class="wizard-price">QTY: ${product.quantity}</span>
              <span class="wizard-price">Unit Price: $${product.price}</span>
              <span class="wizard-url"><a href="/products/${product.url}" target="_blank">View Product</a></span>
            </div>
          </div>
        `
      )
      .join("");
  }

  modal.showModal();


  // Close modal on outside click
  modal.addEventListener('click', function handleOutsideClick(e) {
    const dialogRect = modal.getBoundingClientRect();
    const clickedOutside =
      e.clientX < dialogRect.left ||
      e.clientX > dialogRect.right ||
      e.clientY < dialogRect.top ||
      e.clientY > dialogRect.bottom;

    if (clickedOutside) {
      modal.close();
    }
  }, { once: true }); // only attach once per open

}


function calculatePrice(brandComponentMap) {
  const branchSums = {};

  for (const branch in brandComponentMap['brand_products']) {
    const sum = brandComponentMap['brand_products'][branch].reduce((total, item) => {
      return total + parseFloat(item.price);
    }, 0);
    branchSums[branch] = sum.toFixed(2);
  }

  return branchSums;
}

/*function setAdapters(adapterList, selectedAdapter) {
  console.log(selectedAdapter, 'selected Adapter')
  let options = '<option value="">Select option...</option>';

  adapterList.forEach(adapter => {
    const isSelected = (
      adapter.sku === selectedAdapter["DuraPlus"] ||
      adapter.sku === selectedAdapter["DuraTech"] ||
      adapter.sku === selectedAdapter["Selkirk SuperPro"] ||
      adapter.sku === selectedAdapter["Selkirk Ultra Temp"]
    );

    options += `<option value="${adapter.sku}" ${isSelected ? 'selected' : ''}>${adapter.label}</option>`;
  });

  return options;
}*/

function setAdapters(adapterList, selectedAdapter, brand) {
  let options = '<option value="">Select option...</option>';

  adapterList.forEach(adapter => {
    const isSelected = adapter.sku === selectedAdapter[brand]; // ✅ Only match for current brand
    const variant = adapter.matchingVariant;
    const priceCents = variant?.price || 0;
    const priceDollars = (priceCents / 100).toFixed(2); // Convert to dollars
    const labelWithPrice = `${adapter.label} - $${priceDollars}`;
    options += `<option value="${adapter.sku}" ${isSelected ? 'selected' : ''}>${labelWithPrice}</option>`;
  });

  return options;
}


function closeModal() {
  modal.close();
}

document.querySelectorAll(".cpf-parts-list").forEach((button) => {
  const brand = button.getAttribute("data-target");

  button.addEventListener("click", () => {
    openBrandModal(brand);
  });
});

async function addAvailable(category) {
  const buttons = document.getElementsByClassName("cpf-button-addToCart");
  // Disable all add to cart buttons to prevent multiple clicks
  Array.from(buttons).forEach((button) => (button.disabled = true));

  const products = brandComponentMap['brand_products'][category];

  //console.log(products)

  // Prepare cart items directly using variant_id
  const cartItems = products
    .filter(product => product.variant_id)
    .map(product => ({
      id: product.variant_id,
      quantity: 1
    }));

  //console.log(cartItems)

  if (cartItems.length === 0) {
    console.warn("⚠️ No valid items to add to cart.");
    Array.from(buttons).forEach((button) => (button.disabled = false));
    return;
  }

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: cartItems }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error adding items to cart.");
    }

    const result = await response.json();
    console.log("🛒 Products added to cart:", result);
    updateCartCountOnly();

  } catch (error) {
    console.error("❌ Failed to add to cart:", error.message);
  } finally {
    Array.from(buttons).forEach((button) => (button.disabled = false));
  }
  //return false;

  /*if (!products) {
    console.error(`Category ${category} not found`);
    Array.from(buttons).forEach((button) => (button.disabled = false));
    return;
  }

  try {
    // First fetch all product data in parallel
    const productFetchPromises = products.map((product) =>
      fetch(`/products/${product.url}.js`).then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to fetch product ${product.url}`);
        }
        return res.json();
      })
    );

    const productsData = await Promise.all(productFetchPromises);

    // Prepare cart items
    const cartItems = productsData
      .map((productData, index) => {
        if (!productData.variants || productData.variants.length === 0) {
          console.error(`No variants found for ${products[index].name}`);
          return null;
        }
        return {
          id: productData.variants[0].id,
          quantity: 1,
        };
      })
      .filter((item) => item !== null); // Filter out products with no variants

    if (cartItems.length === 0) {
      console.log("No valid products found to add to cart.");
      return;
    }

    // Make a single cart add request
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: cartItems }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error adding products to cart");
    }

    const result = await response.json();
    console.log("Successfully added all products to cart", result);
    // window.location.href = "/checkout";

    updateCartCountOnly();
    //window.open("/checkout", "_blank");

  } catch (error) {
    console.error("Error:", error);
    console.log(error.message || "An error occurred. Please try again.");
  } finally {
    // Re-enable all add to cart buttons
    const buttons = document.getElementsByClassName("cpf-button-addToCart");
    Array.from(buttons).forEach((button) => (button.disabled = false));
  }*/
}

/*function updateCartCountOnly() {
  $("#CartDrawer .drawer__inner").load(
    location.href + " #CartDrawer .drawer__inner > *"
  );
  openCart();
  $(".cart-count-bubble").load(location.href + " .cart-count-bubble > *");
  $("cart-drawer").removeClass("is-empty");
}*/

function updateCartCountOnly() {
  // Load the inner content of the drawer first
  $("#CartDrawer .drawer__inner").load(
    location.href + " #CartDrawer .drawer__inner > *",
    function () {
      // ✅ Once loaded, open the cart drawer
      openCart();

      // ✅ Update cart count bubble after drawer is loaded
      $(".cart-count-bubble").load(location.href + " .cart-count-bubble > *");

      // ✅ Remove empty class
      $("cart-drawer").removeClass("is-empty");
    }
  );
}

function getAllSurveyAnswers() {
  const answers = [];
  // Installation type
  if (selectedOptions.installation) {
    answers.push({
      question: "Installation: ",
      answer: selectedOptions.installation,
      page: "installation-type",
    });
  }

  // Stove opening diameter
  if (selectedOptions.stove_opening_diameter) {
    answers.push({
      question: "Stove Opening Diameter: ",
      answer: `${selectedOptions.stove_opening_diameter}`,
      page: "stove-opening-diameter",
    });
  }

  // Chimney height to roof
  if (
    selectedOptions.chimney_height_to_roof_ft ||
    selectedOptions.chimney_height_to_roof_in
  ) {
    const ft = parseInt(selectedOptions.chimney_height_to_roof_ft) || 0;
    const inch = parseInt(selectedOptions.chimney_height_to_roof_in) || 0;
  
    if (ft !== 0 || inch !== 0) {
      let formattedHeight = `${ft}'`;
  
      if (inch !== 0) {
        formattedHeight += `${inch}"`;
      }
  
      answers.push({
        question: "Chimney Height to Roof: ",
        answer: formattedHeight,
        page: "mf-chimney-height-to-roof",
      });
    }
  }

  // Additional floors (for default flow)
  if (selectedOptions.additional_floors) {
    answers.push({
      question: "Additional Floors: ",
      answer: selectedOptions.additional_floors,
      page: "mf-additional-floors",
    });
  }

  // Horizontal offset (for default flow)
  if (selectedOptions.require_horizontal_offset) {
    const offsetText =
      selectedOptions.require_horizontal_offset === "1"
        ? `Yes`
        : "No";
    answers.push({
      question: "Horizontal Offset: ",
      answer: offsetText,
      page: "mf-horizontal-offset",
    });
  }

  // Cathedral ceiling pitch
  if (selectedOptions.Ceiling_Pitch) {
    answers.push({
      question: "Cathedral Ceiling Pitch: ",
      answer: `${selectedOptions.Ceiling_Pitch}"`,
      page: "mf-pitch-cathedral-ceiling",
    });
  }

  // Through-wall thickness
  if (selectedOptions.wall_thickness) {
    answers.push({
      question: "Wall Thickness: ",
      answer: `${selectedOptions.wall_thickness} inches`,
      page: "mf-exit-wall-thickness",
    });
  }

  // Wall straps
  if (selectedOptions.wall_straps_step) {
    answers.push({
      question: "Wall Straps: ",
      answer:
        selectedOptions.is_adjustable_wall_straps === "1"
          ? "Adjustable"
          : "Fixed",
      page: "wall-staps-step",
    });
  }

  // Roof type
  if (selectedOptions.roof_type) {
    answers.push({
      question: "Roof Type: ",
      answer: selectedOptions.roof_type,
      page: "roof-type",
    });
  }

  // Roof type
  if (selectedOptions.roof_material) {
    answers.push({
      question: "Roof Type: ",
      answer: selectedOptions.roof_material,
      page: "roof-type",
    });
  }

  // Distance From Peak
  if (selectedOptions.distance_from_peak_ft || selectedOptions.distance_from_peak_in) {
    const ft = selectedOptions.distance_from_peak_ft;
    const inch = selectedOptions.distance_from_peak_in;
  
    let formattedDistance = '';
  
    if (ft) formattedDistance += `${ft}'`;
    else formattedDistance += `0'`;
  
    if (inch || inch === 0) formattedDistance += `${inch}"`;
  
    answers.push({
      question: "Distance from peak: ",
      answer: formattedDistance,
      page: "roof-pitch",
    });
  }


  // Roof pitch
  if (selectedOptions.roof_pitch) {
    answers.push({
      question: "Roof Pitch: ",
      answer: `${selectedOptions.roof_pitch}/12`,
      page: "roof-pitch",
    });
  }

  // Roof pitch
  if (selectedOptions.roog_overhang_step) {
    answers.push({
      question: "Penetrates Overhang: ",
      answer: selectedOptions.roog_overhang_step === "1"
          ? "Yes"
          : "No",
      page: "roog-overhang",
    });
  }

  // Extended roof bracket
  if (selectedOptions.extended_roof_bracket_opt_in) {
    answers.push({
      question: "Extended Roof Bracket: ",
      answer:
        selectedOptions.extended_roof_bracket_opt_in === "1" ? "Yes" : "No",
      page: "extended-roof-bracket",
    });
  }

  // Spark arrestor
  if (selectedOptions.include_spark_arrestor) {
    answers.push({
      question: "Spark Arrestor: ",
      answer: selectedOptions.include_spark_arrestor === "1" ? "Yes" : "No",
      page: "spark-arrestor",
    });
  }

  // Snow splitter
  if (selectedOptions.include_snow_splitter) {
    answers.push({
      question: "Snow Splitter: ",
      answer: selectedOptions.include_snow_splitter === "1" ? "Yes" : "No",
      page: "snow-splitter",
    });
  }

  return answers;
}

// 1. Keep a global object to store selected adapters for all brands
const selectedAdaptersGlobal = {};

// 2. Event listener for adapter changes
document.querySelectorAll('.adaptor-list').forEach(select => {
  select.addEventListener('change', function () {
    const selectedValue = this.value;
    const target = this.dataset.target; // e.g., "DuraPlus"

    // Remove previous adapter if one exists
    brandComponentMap.brand_products[target] = brandComponentMap.brand_products[target].filter(
      product => product.category !== 'Chimney Adapter'
    );

    // 3. Update the global object
    selectedAdaptersGlobal[target] = selectedValue;

    if (selectedValue) {
      fetchAndInsertAdapterProduct(target, selectedValue);
    }

    prices = calculatePrice(brandComponentMap);

    const priceElements = document.querySelectorAll(
      ".cpf-price#subtotal-price"
    );

    // Loop through each element and set the text content based on data-target
    priceElements.forEach((element) => {
      const target = element.getAttribute("data-target");
      if (target && prices[target]) {
        element.textContent = `$${prices[target]}`;
      }
    });

    // 4. Pass the complete object to submitSurvey
    //submitSurvey(selectedAdaptersGlobal);
  });
});

function fetchAndInsertAdapterProduct(brand, sku) {
  const cachedAdapters = brandAdapterCache[brand] || [];
  const adapterData = cachedAdapters.find(a => a.sku === sku);

  if (!adapterData || !adapterData.shopifyProduct) {
    console.warn(`⚠️ No cached adapter found for SKU: ${sku} under brand: ${brand}`);
    return;
  }

  const shopifyProduct = adapterData.shopifyProduct;
  const matchingVariant = shopifyProduct.variants.find(
    (variant) => variant.sku === sku && variant.available
  );

  if (!matchingVariant) {
    console.warn(`❌ No available variant for SKU: ${sku}`);
    return;
  }

  const productInfo = {
    id: matchingVariant.id,
    name: shopifyProduct.title + ' - ' + matchingVariant.title,
    sku: matchingVariant.sku,
    price: (matchingVariant.price / 100).toFixed(2),
    url: shopifyProduct.handle ? `/${shopifyProduct.handle}` : '',
    image: shopifyProduct.images?.[0] || '',
    inventory: matchingVariant.inventory_quantity ?? 0,
    category: 'Chimney Adapter',
    variant_id: matchingVariant.id
  };

  if (!brandComponentMap.brand_products[brand]) {
    brandComponentMap.brand_products[brand] = [];
  }

  // Find index of product with id starting with "gid://shopify/Product/"
  const insertBeforeIndex = brandComponentMap.brand_products[brand].findIndex(
    (p) => typeof p.id === 'string' && p.id.startsWith('gid://shopify/Product/')
  );

  if (insertBeforeIndex !== -1) {
    brandComponentMap.brand_products[brand].splice(insertBeforeIndex, 0, productInfo);
  } else {
    // Fallback: push to end
    brandComponentMap.brand_products[brand].push(productInfo);
  }

  console.log(`✅ Inserted adapter product into brandComponentMap for ${brand}:`, productInfo);
}

function copyMeasurements() {
  // Add event listener to the "Copy" button
  const answerItems = document.querySelectorAll(".survey-answers ul li .d-flex div");
  let clipboardText = "Your Measurements:\n\n";

  answerItems.forEach((item) => {
    console.log(item)
    const question = item.querySelector("strong")?.textContent.trim() || "";
    const answer = item.childNodes[2]?.textContent.trim() || "";
    clipboardText += `${question} ${answer}\n`;
  });

  navigator.clipboard.writeText(clipboardText).then(() => {
    console.log("Measurements copied to clipboard!");
  }).catch((err) => {
    console.error("Failed to copy: ", err);
  });
  
}

/*document.addEventListener("click", function (e) {
  if (e.target && e.target.classList.contains("copy_measurements")) {
    const answerItems = document.querySelectorAll(".survey-answers li");
    let clipboardText = "Your Measurements:\n\n";

    answerItems.forEach((item) => {
      let text = item.innerText.replace(/\s*Edit\s*$/, ''); // Remove trailing "Edit" with or without whitespace
      clipboardText += `${text}\n`;
    });

    navigator.clipboard.writeText(clipboardText).then(() => {
      alert("Measurements copied to clipboard!");
    }).catch((err) => {
      console.error("Failed to copy: ", err);
    });
  }
});*/

document.addEventListener("click", function (e) {
  if (e.target && e.target.classList.contains("copy_measurements")) {
    const button = e.target; // store reference to the clicked button

    const answerItems = document.querySelectorAll(".survey-answers li");
    let clipboardText = "Your Measurements:\n\n";

    answerItems.forEach((item) => {
      let text = item.innerText.replace(/\s*Edit\s*$/, ''); // Remove trailing "Edit"
      clipboardText += `${text}\n`;
    });

    navigator.clipboard.writeText(clipboardText).then(() => {
      button.textContent = "Copied";
      setTimeout(() => {
        button.textContent = "Copy";
      }, 2000);
    }).catch((err) => {
      console.error("Failed to copy: ", err);
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  //localStorage.removeItem('chimneyWizardData');
  //loadWizardData();
  // ✅ Trigger change handler for pre-selected installation
  const preSelectedInstallation = $('input[name="installation"]:checked').val();
  //alert(preSelectedInstallation)
  const newPageFlows = {
    Cathedral: [
      "installation-type",
      "stove-opening-diameter",
      "mf-chimney-height-to-roof",
      "mf-pitch-cathedral-ceiling",
      "roof-type",
      "roof-pitch",
      "extended-roof-bracket",
      "spark-arrestor",
      "snow-splitter",
    ],

    default: [
      "installation-type",
      "stove-opening-diameter",
      "mf-chimney-height-to-roof",
      "mf-additional-floors",
      "mf-horizontal-offset",
      "roof-type",
      "roof-pitch",
      "extended-roof-bracket",
      "spark-arrestor",
      "snow-splitter",
    ],
    "Through-Wall": [
      "installation-type",
      "stove-opening-diameter",
      "mf-chimney-height-to-roof",
      "mf-exit-wall-thickness",
      "wall-staps-step",
      "roof-type",
      "roof-pitch",
      "roog-overhang",
      "extended-roof-bracket",
      "spark-arrestor",
      "snow-splitter",
    ],
  };

  pages = newPageFlows[preSelectedInstallation] || newPageFlows.default;

  if (preSelectedInstallation) {
    $('input[name="installation"]:checked').trigger("change");
    if (preSelectedInstallation == 'Multi-Floor / Through Attic') {
      const checkedValue = $('input[name="require_horizontal_offset"]:checked').val();

      /*if (checkedValue === "1") {
        document.getElementById("offset-details").style.display = "block";
      } else {
        document.getElementById("offset-details").style.display = "none";
      }*/
      document.getElementById("offset-details").style.display =
        checkedValue === "1" ? "block" : "none";
      validatePage();
    }
    
  }

  const savedPage = parseInt(localStorage.getItem("chimneyWizardCurrentPage"), 10);
  // Decide which step to show
  if (!isNaN(savedPage) && savedPage >= 0 && savedPage < pages.length) {
    currentPageIndex = savedPage;
  } else {
    currentPageIndex = 0;
  }
  $(".page").css('display','none');
  let savedSurvey = localStorage.getItem("chimneyWizardComplete");
  if (isNaN(savedSurvey) || savedSurvey == 'null'  || savedSurvey == null) {
    showPage(currentPageIndex);
  } else {
    // Show results section
    document.getElementById("snow-splitter").style.display = "none";
    document.querySelector(".svelte-g6m5ff").style.display = "flex";
  }


  // Select all overlay elements
  const overlays = document.querySelectorAll(".overlay");

  overlays.forEach((overlay) => {
    overlay.addEventListener("click", (e) => {
      // Close popup if clicked outside the .popup content
      if (e.target === overlay) {
       e.preventDefault();

        // 1. Redirect to a dummy anchor
        location.href = '#_';

        // 2. Wait briefly, then remove the hash to avoid scroll
        setTimeout(() => {
          history.pushState("", document.title, window.location.pathname + window.location.search);
        }, 0);
      }
    });
  });
});

function showResultsFromLocalStorage() {
  const saved = JSON.parse(localStorage.getItem("chimneyWizardData") || "{}");
  Object.keys(saved).forEach((key) => {
    const value = saved[key];

    // Restore input values
    const radio = document.querySelector(`input[type="radio"][name="${key}"][value="${value}"]`);
    if (radio) {
      radio.checked = true;
    } else {
      const field = document.querySelector(`[name="${key}"]`);
      if (field) {
        field.value = value;
      }
    }

    // Populate selectedOptions
    selectedOptions[key] = value;
  });

  // ✅ Complete the progress bar
  /*const progress = document.querySelector(".chimney-progress-bar");
  if (progress) {
    progress.style.width = "100%";
    progress.setAttribute("aria-valuenow", "100");
  }

  const surveyContainer = document.querySelector(".page");
  if (surveyContainer) surveyContainer.style.display = "none";*/

  //submitSurvey();
  setTimeout(() => {

    submitSurvey();

    // ✅ Complete the progress bar
    const progress = document.querySelector(".chimney-progress-bar");
    if (progress) {
      progress.style.width = "100%";
      progress.setAttribute("aria-valuenow", "100");
    }

    const surveyContainer = document.querySelector(".page");
    if (surveyContainer) surveyContainer.style.display = "none";
  }, 200);
}

function showPageFromLocalStorage() {
  const saved = JSON.parse(localStorage.getItem("chimneyWizardData") || "{}");
  Object.keys(saved).forEach((key) => {
    const value = saved[key];

    // Restore input values
    const radio = document.querySelector(`input[type="radio"][name="${key}"][value="${value}"]`);
    if (radio) {
      radio.checked = true;
    } else {
      const field = document.querySelector(`[name="${key}"]`);
      if (field) {
        field.value = value;
      }
    }

    // Populate selectedOptions
    selectedOptions[key] = value;
  });
}

function pruneFieldDataByInstallationType(selectedInstallation) {
  const saved = JSON.parse(localStorage.getItem("chimneyWizardData") || "{}");
  const allowedKeys = fieldPageFlows[selectedInstallation] || fieldPageFlows["default"];

  // Remove keys that are not part of the current installation flow
  Object.keys(saved).forEach((key) => {
    if (!allowedKeys.includes(key)) {
      delete saved[key];
    }
  });

  // Save updated data back
  localStorage.setItem("chimneyWizardData", JSON.stringify(saved));
}

function previousPageResult() {
  const preSelectedInstallation = $('input[name="installation"]:checked').val();
  pages = pageFlows[preSelectedInstallation] || pageFlows.default;
  const newIndex = pages.indexOf('snow-splitter');
  currentPageIndex = newIndex !== -1 ? newIndex : 0;
  //return false;
  if (currentPageIndex > 0) {
    localStorage.removeItem("chimneyWizardComplete");
    $(".cw-main-result").css('display', 'none');
    updateProgressBar();
    //currentPageIndex--;
    //showPage(currentPageIndex);
    localStorage.setItem("chimneyWizardCurrentPage", currentPageIndex);
    showPage(currentPageIndex);
    validatePage();
  }
}